import { zhCNLegalContent } from '../legalContent'

export default {
  brand: {
    logoAlt: 'LPT Logo'
  },
  legal: zhCNLegalContent,
  language: {
    en: "English",
    fr: "法语",
    es: "西班牙语",
    zh: "中文",
    de: "德语"
  },
  navbar: {
    Index: "首页",
    Products: "产品",
    Audit: "审计",
    solution: "解决方案",
    about: "关于我们",
    News: "新闻",
    Customer_Service: "特点及解决方案",
    controlCenter: "控制中心",
    login: "登录",
    Language: "语言",
    logout: "退出",
    logoutSuccess: "注销成功",
    FAQ: "常问问题",
    AboutLPT: "关于LPT",
    LPTIntro: "LPT简介",
    ContactLPT: "联系LPT",
    Company: "公司",
    IndustryBrain: "产业大脑",
    CloudRecruitment: "云招商",
    InnovationServices: "企业创新服务",
    Consulting: "产业咨询",
    ContentCenter: "内容中心",
    IndustryReports: "行业报告",
    SelectedArticles: "精选文章",
    MediaReports: "媒体报道",
    LPTResearch: "LPT研究院",
    LPTIntroduction: "关于LPT",
    BuyNow: "立即购买"
  },
  serverConfig: {
    computeInstance: {
      title: "计算实例",
      recommend: "推荐",
      types: {
        g7: { name: "通用型 G7", type: "通用型" },
        c7: { name: "计算优化型 C7", type: "计算优化型" },
        r7: { name: "内存优化型 R7", type: "内存优化型" }
      },
      specs: { cpu: " vCPU", memory: " GB" },
      price: { currency: "€", period: " / 月" }
    },
    storageConfig: {
      title: "存储配置",
      types: {
        essd: "增强型 SSD",
        essdDesc: "百万级 IOPS",
        ssd: "标准 SSD",
        ssdDesc: "企业级性能",
        hdd: "高效 HDD",
        hddDesc: "大容量存储",
        performance: { iops: "IOPS：", latency: "延迟：" }
      },
      capacity: { label: "存储容量", unitGB: " GB" }
    }
  },
  registration: {
    organization: "组织名称",
    legalRepresentative: "法定代表人",
    businessRegistrationNumber: "工商注册号",
    taxIdNumber: "税号",
    businessAddress: "营业地址",
    phoneNumber: "电话号码",
    wechatId: "微信号",
    email: "电子邮箱",
    createPassword: "创建密码",
    repeatPassword: "再次输入密码",
    accept: "我接受",
    termsConditions: "条款与条件"
  },
  dialog: {
    termsTitle: "条款与条件"
  },
  common: {
    close: "关闭",
    loading: "加载中..."
  },
  validation: {
    required: "此项为必填项。",
    lengthRange: "请输入 {min} 至 {max} 个字符。",
    regNumberFormat: "请输入有效的 15 位注册号。",
    passwordComplexity: "密码至少包含 8 个字符，并同时包含大写字母、小写字母和数字。",
    passwordMismatch: "两次输入的密码不一致。",
    agreementRequired: "请接受条款与条件。"
  },
  message: {
    validationFailed: "请修正标记的字段。"
  },
  payment: {
    steps: {
      methodSelection: "支付方式",
      paymentProcess: "支付",
      paymentResult: "支付结果"
    },
    methods: {
      wechat: { name: "微信支付", tip: "推荐微信用户使用" },
      alipay: { name: "支付宝", tip: "支持花呗和余额宝" },
      mastercard: { name: "Mastercard", tip: "支持国际信用卡" }
    },
    qrCode: {
      scanPrompt: "扫描 {method} 二维码付款",
      countdown: "二维码将在 {seconds} 秒后失效"
    },
    form: {
      cardNumber: "卡号",
      expiryDate: "有效期",
      cvv: "CVV",
      placeholders: {
        cardNumber: "请输入卡号",
        expiry: "请选择有效期",
        cvv: "请输入 CVV"
      }
    },
    buttons: { previous: "上一步", payNow: "立即支付" },
    errors: { bankBusy: "银行系统繁忙，请稍后重试。" },
    result: {
      success: { title: "支付成功", subTitle: "您的订单已支付，我们正在准备相关产品。" },
      failed: { title: "支付失败", subTitle: "未能完成支付，请重试。" },
      returnHome: "返回首页"
    }
  },
  periodSelect: {
    Monthlypurchase: "按月购买",
    Annual: "按年购买"
  },
  datePicker: {
    rangeSeparator: "至",
    startMonth: "开始月份",
    endMonth: "结束月份"
  },
  networkConfig: {
    title: "网络配置"
  },
  priceSummary: {
    title: "价格汇总",
    serviceDuration: "服务时长：{months} 个月",
    unitPrice: "单价：{price}",
    totalPrice: "总价：{total}"
  },
  orderDetails: {
    title: "订单详情",
    companyName: "公司",
    template: "模板",
    storage: "存储",
    storageUnitGB: "GB",
    computeLevel: "计算等级",
    servicePeriod: "服务周期",
    totalAmount: "总金额",
    defaultPeriod: "2023 年 7 月至 2024 年 6 月"
  },
  agreement: {
    readAndAgree: "我已阅读并同意",
    serviceAgreement: "服务协议",
    and: "和",
    privacyPolicy: "隐私政策"
  },
  template: {
    header: { title: "选择审计模板", selectedCount: "已选择 {count} 个" },
    tags: { pro: "PRO", basic: "BASIC" },
    names: {
      iso9001: "ISO 9001", iatf16949: "IATF 16949", vda63: "VDA 6.3", vda65: "VDA 6.5",
      individualPro: "自定义模板创建器（Pro）", individualBasic: "自定义模板创建器"
    },
    description: "面向制造业的智能生产管理系统。",
    alerts: {
      incompatible: "此模板与已选择的模板不兼容。",
      conflict: "模板 {template} 与已选择的模板冲突：{selected}"
    }
  },
  demo: {
    title: "预约产品演示",
    subtitle: "请告诉我们您的需求，我们的团队将与您联系。",
    form: {
      serviceLabel: "感兴趣的产品或服务",
      servicePlaceholder: "请选择产品或服务",
      services: {
        auditPlatform: "审计平台",
        complianceManagement: "合规管理",
        riskAssessment: "风险评估",
        auditConsulting: "审计咨询"
      },
      nameLabel: "姓名", namePlaceholder: "请输入姓名",
      phoneLabel: "电话号码", phonePlaceholder: "请输入电话号码",
      codeLabel: "验证码", codePlaceholder: "请输入验证码", getCodeButton: "获取验证码",
      emailLabel: "电子邮箱", emailPlaceholder: "请输入电子邮箱",
      companyLabel: "政府 / 园区 / 组织 / 公司", companyPlaceholder: "请输入公司名称",
      positionLabel: "职位", positionPlaceholder: "请输入职位",
      remarksLabel: "备注", remarksPlaceholder: "请描述您的问题或需求（最多 200 个字符）",
      privacyAgreement: "提交即表示您同意 LPT Creation 的隐私政策",
      submitButton: "立即预约"
    }
  },
  back: "返回",
  controlCenter: {
    sidebar: {
      title: "控制中心",
      subtitle: "审计、支付与商品管理",
      dashboard: "审计总览",
      paymentDashboard: "支付看板",
      companyEntitlements: "公司购买总览",
      myProducts: "我的商品",
      catalog: "商品目录管理",
      orders: "订单管理",
      invoices: "发票管理",
      tickets: "工单管理",
      addOnManagement: "插件管理",
      userManagement: "用户管理",
      permissionManagement: "权限管理",
      systemSettings: "系统设置",
      appManagement: "应用管理",
      accountInfo: "账号"
    },
    invoices: {
      title: "发票管理",
      subtitle: "为订单上传和查看发票。",
      notUploaded: "未上传",
      deleteFile: "删除文件",
      deleting: "删除中...",
      deleteConfirm: "确定删除该发票文件吗？删除后可以重新上传。",
      deleteSuccess: "发票文件已删除。",
      deleteError: "删除发票文件失败。",
      snapshot: "已固化快照",
      overview: {
        total: "订单总数",
        uploaded: "本页已上传",
        pending: "待上传",
        coverage: "本页完成率"
      },
      columns: {
        invoice: "发票"
      }
    },
    accessDenied: {
      title: "需要管理员权限",
      description: "当前区域仅对管理员账号开放。"
    },
    common: {
      loading: "加载中...",
      shop: "SHOP",
      refresh: "刷新",
      save: "保存",
      cancel: "取消",
      edit: "编辑",
      enable: "启用",
      disable: "停用",
      actions: "操作",
      all: "全部",
      search: "查询",
      reset: "重置",
      viewDetails: "查看详情",
      close: "关闭",
      confirm: "确认",
      exitToHome: "返回首页",
      unknown: "未知",
      status: "状态"
    },
    statusLabels: {
      PENDING: "待支付",
      SUCCESS: "支付成功",
      ACTIVE: "已生效",
      FAILED: "支付失败",
      CANCELED: "已取消",
      PAST_DUE: "已逾期",
      UNKNOWN: "未知"
    },
    billingCycleLabels: {
      one_year: "1 年",
      two_year: "2 年"
    },
    ticketStatusLabels: {
      OPEN: "处理中",
      CLOSED: "已关闭",
      UNKNOWN: "未知"
    },
    ticketCategories: {
      REFUND: "退款",
      LICENSE: "许可",
      LOGIN: "登录",
      AUDIT: "审计",
      OTHER: "其他"
    },
    ticketAuthorTypes: {
      EMPLOYEE: "LPT 员工",
      CUSTOMER: "客户",
      UNKNOWN: "未知"
    },
    dashboard: {
      title: "支付看板",
      subtitle: "集中查看订单、收入和热门商品。",
      totalOrders: "订单总数",
      successfulOrders: "成功订单",
      pendingOrders: "待支付订单",
      failedOrders: "异常订单",
      totalRevenue: "累计收入",
      trendTitle: "最近 7 天趋势",
      trendDate: "日期",
      trendOrders: "订单数",
      trendRevenue: "收入",
      recentOrders: "最近订单",
      popularItems: "热门商品",
      orderNo: "订单号",
      company: "公司",
      amount: "金额",
      createdAt: "创建时间",
      noPopularItems: "暂无热门商品数据。",
      loadError: "加载支付看板失败。"
    },
    companyEntitlements: {
      title: "公司购买总览",
      subtitle: "查看所有公司、已购买内容以及许可开始和到期时间。",
      keywordPlaceholder: "按公司、订单、用户或套餐搜索",
      empty: "暂无公司购买记录。",
      loadError: "加载公司购买记录失败。",
      seatSummary: "{auditors} 个审核员 / {admins} 个管理员",
      stats: {
        companies: "公司数",
        activeCompanies: "生效公司",
        entitlements: "权益数",
        seats: "总席位"
      },
      columns: {
        company: "公司",
        activeEntitlements: "生效 / 总数",
        purchasedItems: "已购买内容",
        seats: "席位",
        startsAt: "开始时间",
        expiresAt: "到期时间"
      },
      fields: {
        billingCycle: "计费周期",
        validity: "有效期",
        seats: "席位",
        updatedAt: "更新时间",
        languages: "语言",
        standards: "审核模板"
      }
    },
    myProducts: {
      title: "我的商品",
      subtitle: "查看当前账户已拥有的套餐、插件和到期时间。",
      activeKicker: "正在使用",
      activeTitle: "正在使用",
      expiredKicker: "历史记录",
      expiredTitle: "已过期",
      expiresAt: "到期时间",
      expiredAt: "过期时间",
      startsAt: "开始时间",
      sourceOrder: "来源订单",
      quantity: "{count} 件",
      loadError: "加载我的商品失败。",
      emptyActiveTitle: "暂无正在使用的商品",
      emptyActiveText: "支付成功后的商品会显示在这里。",
      emptyExpiredTitle: "暂无已过期商品",
      emptyExpiredText: "过期商品会归档到这里。",
      stats: {
        active: "正在使用",
        expired: "已过期",
        total: "共 {count} 个商品",
        nextExpiry: "{product} 将于 {date} 到期",
        noExpiry: "暂无到期时间"
      },
      groups: {
        package: {
          kicker: "Package",
          title: "Package",
          emptyActiveTitle: "暂无正在使用的 Package",
          emptyActiveText: "购买成功后的 Package 会显示在这里。",
          emptyExpiredTitle: "暂无已过期 Package",
          emptyExpiredText: "已过期的 Package 会显示在这里。"
        },
        language: {
          kicker: "语言",
          title: "语言",
          emptyActiveTitle: "暂无正在使用的语言",
          emptyActiveText: "购买成功后的语言会显示在这里。",
          emptyExpiredTitle: "暂无已过期语言",
          emptyExpiredText: "已过期的语言会显示在这里。"
        },
        standard: {
          kicker: "Standards",
          title: "Standards",
          emptyActiveTitle: "暂无正在使用的 Standards",
          emptyActiveText: "购买成功后的 Standards 会显示在这里。",
          emptyExpiredTitle: "暂无已过期 Standards",
          emptyExpiredText: "已过期的 Standards 会显示在这里。"
        },
        licence: {
          kicker: "许可",
          title: "许可",
          emptyActiveTitle: "暂无正在使用的许可",
          emptyActiveText: "购买成功后的许可会显示在这里。",
          emptyExpiredTitle: "暂无已过期许可",
          emptyExpiredText: "已过期的许可会显示在这里。"
        }
      },
      status: {
        active: "生效中"
      },
      types: {
        licence: "许可",
        auditorSeat: "审核员许可",
        adminSeat: "管理员席位"
      },
      descriptions: {
        plan: "主套餐 · {cycle}",
        language: "附加语言能力",
        standard: "附加审核模板",
        seat: "附加许可数量：{count}",
        addOn: "已购买的插件能力"
      },
      actions: {
        createAuditor: "创建用户"
      }
    },
    catalog: {
      title: "商品目录管理",
      subtitle: "维护购买页显示的商品名称、价格、席位档位和上下架状态。",
      create: "新增商品",
      createTitle: "新增商品",
      editTitle: "编辑商品",
      enabled: "已启用",
      disabled: "已停用",
      unlimited: "不限",
      loadError: "加载商品目录失败。",
      createSuccess: "商品创建成功。",
      updateSuccess: "商品更新成功。",
      saveError: "保存商品失败。",
      enableSuccess: "商品已启用。",
      disableSuccess: "商品已停用。",
      columns: {
        type: "类型",
        code: "编码",
        name: "名称",
        currency: "币种",
        oneYear: "1 年价格",
        twoYears: "2 年价格",
        seatCount: "席位数",
        languageLimit: "语言上限",
        sortOrder: "排序",
        enabled: "状态"
      },
      types: {
        plan: "套餐",
        language: "语言",
        standard: "审核模板",
        auditorSeat: "审核员席位",
        adminSeat: "管理员席位"
      }
    },
    orders: {
      title: "订单管理",
      subtitle: "按订单号、公司、状态和支付方式查看全部订单。",
      keywordPlaceholder: "搜索订单号或公司名称",
      syncStatus: "同步状态",
      uploadInvoice: "上传发票",
      invoiceUploading: "上传中...",
      viewInvoice: "查看发票",
      storageTag: "存储·附属",
      invoiceUploadSuccess: "发票上传成功。",
      invoiceUploadError: "发票上传失败。",
      invoiceTypeError: "请上传 PDF、PNG 或 JPG 格式的发票。",
      invoiceSizeError: "发票文件不能超过 10 MB。",
      detailTitle: "订单详情",
      invoiceItems: "发票明细",
      companyInfo: "公司信息",
      defaultInvoiceInfo: "默认发票信息",
      noDefaultInvoiceInfo: "尚未设置默认发票信息。",
      contactName: "联系人",
      email: "邮箱",
      phone: "电话",
      registrationNumber: "注册号",
      address: "地址",
      loadError: "加载订单列表失败。",
      detailError: "加载订单详情失败。",
      syncSuccess: "订单状态已同步。",
      syncError: "同步订单状态失败。",
      columns: {
        orderNo: "订单号",
        company: "公司",
        plan: "套餐",
        billingCycle: "购买时长",
        amount: "金额",
        paymentMethod: "支付方式",
        createdAt: "创建时间"
      }
    },
    tickets: {
      title: "工单管理",
      subtitle: "查询、查看并回复客户支持工单。",
      create: "新建工单",
      createTitle: "创建工单",
      detailTitle: "工单详情",
      searchPlaceholder: "搜索工单",
      titlePlaceholder: "请输入工单标题",
      categoryPlaceholder: "请选择工单类别",
      titleRequired: "请输入工单标题。",
      categoryRequired: "请选择工单类别。",
      empty: "暂无工单。",
      messages: "消息记录",
      noMessages: "暂无消息。",
      replyPlaceholder: "请输入回复内容",
      sendMessage: "发送消息",
      closeTicket: "关闭工单",
      closeConfirmTitle: "关闭工单",
      closeConfirmMessage: "确定要关闭该工单吗？",
      loadError: "加载工单列表失败。",
      detailError: "加载工单详情失败。",
      createSuccess: "工单创建成功。",
      createError: "创建工单失败。",
      replyRequired: "请输入消息内容。",
      replySuccess: "消息已发送。",
      replyError: "发送消息失败。",
      closeSuccess: "工单已关闭。",
      closeError: "关闭工单失败。",
      missingId: "缺少工单 ID。",
      columns: {
        id: "工单 ID",
        title: "标题",
        category: "类别",
        createdBy: "创建人",
        createdAt: "创建时间"
      }
    },
    auditDashboard: {
      title: "审计总览",
      eyebrow: "经营指挥看板",
      subtitle: "集中查看审计购买、权益、席位、标准模板和运营健康度。",
      startNewAudit: "发起新审计",
      activeAuditors: "活跃审计员",
      auditorsAvailable: "{count} 名审计员可用",
      purchasedModules: "已购模块",
      newThisMonth: "本月新增 {count} 个",
      auditsInProgress: "进行中的审计",
      ongoing: "{count} 个进行中",
      reportsToReview: "待复核报告",
      viewReports: "查看报告",
      activityOverview: "审计活动概览",
      timePeriods: {
        month: "月",
        week: "周",
        day: "日"
      },
      inProgressAudits: "进行中的审计",
      projectName: "项目名称",
      leadAuditor: "主审计员",
      progress: "进度",
      dueDate: "截止日期",
      recentReports: "最近报告",
      completedBy: "{auditor} 于 {date} 完成",
      loadError: "加载审计总览失败。",
      cards: {
        totalOrders: "订单总数",
        orderMix: "{success} 个成功 / {pending} 个待支付",
        totalRevenue: "累计收入",
        failedOrders: "{count} 个失败或取消订单",
        activeEntitlements: "有效权益",
        expiring: "{count} 个即将到期",
        auditorSeats: "审计员席位",
        adminSeats: "{count} 个管理员席位",
        catalogItems: "启用商品",
        catalogTotal: "共 {count} 个商品",
        invoiceCoverage: "发票覆盖率",
        invoiceUploaded: "{count} 个订单已开票"
      },
      sections: {
        orderMovement: "订单走势",
        orderMovementSub: "最近 14 天每日订单量",
        auditHealth: "审计业务健康度",
        auditHealthSub: "成功率、开票和权益激活综合评估",
        revenueMix: "套餐收入结构",
        capabilityComposition: "能力构成",
        capabilityCompositionSub: "订单、席位、商品和发票准备度",
        entitlementHealth: "权益健康",
        entitlementHealthSub: "当前许可生命周期状态",
        methodMix: "支付方式结构",
        methodMixSub: "按支付方式统计订单数量",
        standardDemand: "标准模板需求",
        standardDemandSub: "购买最多的审计模板",
        recentOrders: "最近订单",
        recentOrdersSub: "最新客户购买动态",
        expiringEntitlements: "即将到期权益",
        expiringEntitlementsSub: "30 天内到期的许可"
      },
      labels: {
        healthScore: "健康度",
        orders: "订单",
        successOrders: "成功订单",
        auditorSeats: "审计员席位",
        adminSeats: "管理员席位",
        enabledCatalog: "启用商品",
        invoices: "发票",
        days: "天"
      },
      empty: {
        noData: "暂无数据。",
        noOrders: "暂无最近订单。",
        noExpiring: "暂无即将到期权益。"
      },
      paymentMethods: {
        card: "银行卡",
        alipay: "支付宝",
        wechat: "微信支付",
        visa: "Visa",
        mastercard: "Mastercard",
        unknown: "未知"
      },
      plans: {
        starter: "基础版",
        professional: "专业版",
        enterprise: "企业版"
      }
    },
    userManagement: {
      subtitle: "管理审计员、个人资料和账户权限。",
      createAuditor: "创建用户",
      allUserTypes: "全部用户类型",
      typeAdministrator: "管理员",
      typeAuditor: "用户",
      searchPlaceholder: "按姓名或邮箱搜索用户",
      myProfile: "我的资料",
      noAuditorsFound: "暂无审计员。",
      userName: "用户姓名",
      email: "邮箱",
      userType: "用户类型",
      createdDate: "创建日期",
      lastUsed: "上次使用",
      showUnassignableUsers: "显示不可分配的用户",
      assignSeat: "分配席位",
      selectSeat: "选择席位",
      noAvailableSeats: "暂无可用席位，请购买更多席位。",
      assignSeatDeniedTitle: "无法分配席位",
      assignSeatDeniedMessage: "只有审计员用户类型可以被分配席位，当前用户类型不是审计员。",
      noAvailableLicence: "暂无可用许可，请先购买更多 Licences。",
      neverLogged: "从未登录",
      status: "状态",
      active: "启用",
      inactive: "停用",
      actions: "操作",
      editAuditor: "编辑审计员",
      permissionSetting: "权限设置",
      changePassword: "修改密码",
      changePasswordTitle: "修改密码",
      delete: "删除",
      addAuditorModalTitle: "添加审计员",
      firstName: "名",
      lastName: "姓",
      cancel: "取消",
      saving: "保存中...",
      saveChanges: "保存修改",
      personalInfo: "个人信息",
      phoneNumber: "电话号码",
      nationality: "国籍",
      sex: "性别",
      organizationInfo: "组织信息",
      organizationName: "组织名称",
      legalName: "法定名称",
      contactEmail: "联系邮箱",
      address: "地址",
      quotaInfo: "配额信息",
      maxAuditorCount: "最大审计员数量",
      accountCreatedDate: "账户创建日期",
      close: "关闭",
      updateSuccess: "用户更新成功。",
      addSuccess: "用户添加成功。",
      updateErrorOnceAYear: "该信息每年只能修改一次。",
      saveError: "保存用户失败。",
      loadError: "加载审计员失败。",
      confirmDeleteMsg: "确定要删除 {userName} 吗？",
      confirmDeleteTitle: "删除审计员",
      deleteSuccess: "审计员删除成功。",
      deleteError: "删除用户失败。",
      createAuditorTitle: "创建用户",
      basicInfo: "基础信息",
      firstNamePlaceholder: "请输入名",
      lastNamePlaceholder: "请输入姓",
      emailPlaceholder: "请输入邮箱地址",
      password: "密码",
      passwordPlaceholder: "请输入密码",
      passwordHint: "至少 8 个字符，并包含字母和数字。",
      currentPassword: "当前密码",
      newPassword: "新密码",
      confirmPassword: "确认密码",
      passwordRequired: "请输入当前密码和新密码。",
      passwordMismatch: "两次输入的密码不一致。",
      changePasswordSuccess: "密码修改成功。",
      changePasswordError: "修改密码失败。",
      sexUnknown: "不便透露",
      sexMale: "男",
      sexFemale: "女",
      birthday: "生日",
      phoneNumberPlaceholder: "请输入电话号码",
      selectNationality: "请选择国籍",
      addressInfo: "地址信息",
      country: "国家",
      selectCountry: "请选择国家",
      stateOrProvince: "州/省",
      statePlaceholder: "请输入州或省",
      city: "城市",
      cityPlaceholder: "请输入城市",
      postalCode: "邮政编码",
      postalCodePlaceholder: "请输入邮政编码",
      addressLine1: "地址行 1",
      addressLine1Placeholder: "请输入街道地址",
      addressLine2: "地址行 2",
      addressLine2Placeholder: "请输入公寓、套房或单元",
      enableUser: "启用用户",
      creating: "创建中...",
      createSuccess: "用户创建成功。",
      createError: "创建用户失败。",
      permissionDialogTitle: "{userName} 的权限",
      permissions: "权限",
      assignSuccess: "权限更新成功。",
      permissionLoadError: "加载权限数据失败。",
      permissionGroups: {
        user: "用户管理",
        permission: "权限管理",
        group: "用户组管理",
        account: "账户管理",
        audit: "审计管理",
        report: "报告管理"
      }
    },
    permissionManagement: {
      subtitle: "配置权限策略和访问控制。",
      comingSoon: "权限管理功能即将上线。"
    },
    addOnManagement: {
      subtitle: "为当前账号加购语言、审计标准和许可席位。",
      currentPackage: "当前 Package",
      noPackage: "暂无生效 Package",
      addOnAvailable: "可加购",
      addOnLocked: "不可加购",
      packageAvailable: "当前 Package 支持加购语言、Standards 和许可。",
      starterRestriction: "Starter package 不支持加购，需要购买更高级的套装。",
      purchaseDuration: "购买时长",
      chooseDuration: "选择加购有效期",
      forOneYear: "1 年",
      forTwoYears: "2 年",
      itemCount: "{count} 项",
      standardTemplate: "审计标准模板",
      licenceCapacity: "额外许可容量",
      currentExpiry: "当前到期：{date}",
      notActive: "未生效",
      expiryChange: "当前 {current} -> 加购后 {projected}",
      emptyCategory: "该分类暂无可加购项。",
      emptySelection: "请选择一个或多个加购项后创建订单。",
      orderSummary: "订单",
      selectedAddOns: "已选加购项",
      total: "合计",
      confirmAndPay: "确认并支付",
      summaryNote: "价格不含税，最终扣款金额以后端订单确认为准。",
      selectRequired: "请至少选择一个加购项。",
      createOrderError: "创建加购订单失败。",
      loadErrorTitle: "加购项不可用",
      loadError: "加载加购选项失败，请刷新后重试。",
      checkout: "收银台",
      completePayment: "完成加购支付",
      paymentIntro: "使用与购买流程一致的安全支付方式。",
      backToSelection: "返回选择",
      auditorSeatsName: "{count} 个审计员许可",
      auditorSeatsDesc: "用于执行审计和生成报告的额外审计员席位。",
      adminSeatsName: "{count} 个管理员许可",
      adminSeatsDesc: "用于用户与权限管理的额外管理员席位。",
      licencesName: "{count} 个许可",
      licencesDesc: "按单个数量增加普通审计许可，适用于执行审计和生成报告的团队成员。",
      licenceSelectedCount: "已选 {count} 个",
      licenceUnitPrice: "{price} / 许可 / 月",
      licenceCountLabel: "许可",
      decreaseLicence: "减少许可",
      increaseLicence: "增加许可",
      singleCapability: "单项能力",
      seatQuantity: "{count} 个席位",
      categories: {
        languages: {
          title: "Languages",
          desc: "在不变更基础套餐的情况下增加审计系统语言。"
        },
        standards: {
          title: "Standards",
          desc: "加购额外审计模板，并可延长已购模板有效期。"
        },
        licences: {
          title: "Licences",
          desc: "按单个数量增加普通许可；供应商和客户门户仍保持无限制。"
        }
      },
      types: {
        language: "语言",
        standard: "标准",
        licence: "许可",
        auditorSeat: "审计员席位",
        adminSeat: "管理员席位",
        addOn: "加购项"
      }
    },
    systemSettings: {
      subtitle: "管理组织资料、地址和联系方式。",
      loading: "正在加载设置...",
      orgInfo: "组织信息",
      orgName: "组织名称",
      legalName: "法定名称",
      industry: "行业",
      selectIndustry: "请选择",
      regNum: "注册号",
      taxId: "税号",
      addressContact: "地址与联系方式",
      address: "地址",
      country: "国家",
      city: "城市",
      postalCode: "邮政编码",
      contactEmail: "联系邮箱",
      phone: "电话",
      loadError: "加载组织设置失败。",
      updateSuccess: "组织设置更新成功。",
      saveError: "保存组织设置失败。",
      industries: {
        healthCare: "医疗健康",
        dataAndAnalytics: "数据与分析",
        finance: "金融服务",
        technology: "科技",
        education: "教育",
        manufacturing: "制造业",
        retail: "零售",
        transportation: "交通运输"
      }
    },
    appManagement: {
      title: "应用管理",
      subtitle: "管理公司应用产品，Provision、Suspend、Resume 或 Deprovision 应用。",
      keywordPlaceholder: "搜索应用名称、编码或公司",
      empty: "暂无应用数据。",
      loadError: "加载应用列表失败。",
      section: {
        active: "已开通的应用",
        suspend: "已停用的应用",
        notProvisioned: "未开通的应用"
      },
      stats: {
        totalApps: "应用总数",
        activeApps: "Active",
        suspendedApps: "Suspended",
        notProvisionedApps: "Not Provisioned"
      },
      columns: {
        appName: "应用名称",
        company: "公司",
        status: "状态",
        createdAt: "开通时间",
        expiredAt: "到期时间"
      },
      statusLabels: {
        ACTIVE: "Active",
        SUSPENDED: "Suspended",
        NOT_PROVISIONED: "Not Provisioned",
        DEPROVISIONED: "Deprovisioned"
      },
      actions: {
        provision: "开通",
        suspend: "停用",
        resume: "恢复",
        deprovision: "注销"
      },
      messages: {
        provisionSuccess: "应用已成功 Provision。",
        provisionError: "Provision 应用失败。",
        suspendSuccess: "应用已成功 Suspend。",
        suspendError: "Suspend 应用失败。",
        resumeSuccess: "应用已成功 Resume。",
        resumeError: "Resume 应用失败。",
        deprovisionSuccess: "应用已成功 Deprovision。",
        deprovisionError: "Deprovision 应用失败。"
      },
      dialogs: {
        deprovision: {
          title: "Deprovision 应用",
          message: "确定要 Deprovision 应用「{appName}」吗？Deprovision 后将无法恢复。",
          confirm: "确认 Deprovision"
        }
      }
    },
    auditorSeatManagement: {
      title: "席位状态",
      empty: "暂无席位数据。",
      loadError: "加载席位数据失败。",
      forcedLogout: "您没有权限访问该页面，已自动登出。",
      goToActivate: "去激活",
      buyNow: "立即购买",
      unassigned: "未分配",
      actions: {
        rename: "重命名",
        assign: "分配",
        unassign: "解除分配"
      },
      messages: {
        renameSuccess: "席位重命名成功。",
        renameError: "席位重命名失败。",
        assignSuccess: "审计员分配成功。",
        assignError: "如需解除席位分配，请联系客服。",
        unassignSuccess: "解除分配成功。",
        unassignError: "如需解除席位分配，请联系客服。",
        copied: "已复制"
      },
      fields: {
        name: "姓名",
        isAuditUser: "Audit用户",
        auditUserNumeral: "审计用户编号",
        auditUserType: "Audit用户类型",
        notAuditUserPlaceholder: "还不是Audit用户",
        hasSeat: "席位状态",
        hasSeatTooltipTrue: "已被分配席位",
        hasSeatTooltipFalse: "暂无席位",
        email: "邮箱",
        lastLoginTime: "最后一次使用",
        yes: "是",
        no: "否"
      },
      auditUserTypes: {
        AUDITOR: "审计员",
        AUDITOR_INTERNAL_USER: "审计内部用户",
        SUPPLIER_REPRESENTATIVE: "供应商代表",
        SUPPLIER_INTERNAL_USER: "供应商内部用户",
        CLIENT: "客户代表",
        GUEST: "访客",
        placeholder: "-"
      },
      dialogs: {
        rename: {
          title: "重命名席位",
          nameLabel: "席位名称"
        },
        assign: {
          title: "分配审计员",
          auditorLabel: "选择审计员",
          auditorPlaceholder: "请选择审计员",
          searchPlaceholder: "搜索姓名 / 邮箱 / 审计用户编号",
          countSuffix: "条",
          empty: "暂无符合条件的用户",
          assignableTag: "可分配",
          unassignableTag: "不可分配",
          warningTitle: "重要提示",
          warningMessage: "请谨慎选择指定审计员。请确认分配对象无误后再进行操作。席位一旦分配成功，将无法由您自行取消。如需取消分配，请联系客服处理。",
          acknowledgeLabel: "我已了解",
          showUnassignableLabel: "显示不可分配用户",
          nonAuditorBlockTip: "只有“审计员”可以被分配席位，当前所选用户不是审计员",
          seatReplaceWarning: "该用户已被分配的席位将被替换",
          notAuditUserInfo: "席位只能分配给audit用户，当前所选用户暂未注册为audit用户，是否自动将其注册为audit审计员用户？",
          autoRegisterLabel: "自动注册为审计员用户"
        }
      },
      assignPage: {
        title: "分配审计员",
        subtitle: "为席位选择一位审计员。列表展示所有账户下的身份信息，请谨慎选择。",
        backToList: "返回",
        seatInfoTitle: "席位信息",
        seatNameLabel: "席位名称",
        seatStatusLabel: "当前状态",
        seatAssigned: "已分配",
        seatUnassigned: "未分配",
        loadingSeat: "正在加载席位信息",
        seatNotFound: "未找到该席位，请返回列表重试。",
        confirmAssign: "确认分配",
        cancel: "取消"
      }
    },
    accountInfo: {
      title: "账号",
      subtitle: "查看账号详情和组织信息。",
      accountDetails: "账号详情",
      accountId: "账号标识",
      accountType: "账号类型",
      creationTime: "创建时间",
      administrator: "管理员",
      organizationInfo: "组织信息",
      loadError: "加载账号信息失败。",
      accountIdError: "无法获取账号标识。",
      copied: "已复制",
      copyFailed: "复制失败",
      change: "变更",
      changeAdminTip: "请联系客户服务变更账号管理员。",
      close: "关闭",
      organization: {
        name: "组织名称",
        legalName: "法定名称",
        contactEmail: "联系邮箱",
        phoneNumber: "电话号码",
        industries: "行业",
        taxIdentificationNumber: "税号",
        legalRepresentative: "法定代表人",
        registration: "注册信息",
        registrationNumber: "注册号",
        registrationType: "注册类型",
        registrationDocument: "注册文件",
        countryOrRegion: "国家/地区",
        stateOrProvince: "州/省",
        city: "城市",
        postalCode: "邮政编码",
        address: "地址",
        addressLine1: "地址行1",
        addressLine2: "地址行2"
      },
      invoiceInfo: {
        title: "发票信息",
        addButton: "新增发票信息管理",
        empty: "暂无发票信息",
        dialogTitleAdd: "新增发票信息",
        dialogTitleEdit: "编辑发票信息",
        fields: {
          title: "发票抬头",
          taxId: "税号（纳税人识别号）",
          address: "单位地址",
          phone: "电话",
          bankName: "开户银行",
          bankAccount: "银行账号",
          bankAddresses: "银行地址"
        },
        addBankAddress: "添加银行地址",
        edit: "编辑",
        delete: "删除",
        save: "保存",
        cancel: "取消",
        deleteConfirm: "确定删除该发票信息吗？",
        loadError: "加载发票信息失败。",
        saveSuccess: "发票信息已保存。",
        deleteSuccess: "发票信息已删除。",
        saveFailed: "保存发票信息失败。",
        deleteFailed: "删除发票信息失败。",
        titleRequired: "请输入发票抬头。"
      }
    },
  },
  newFeatures: {
    title: "新功能",
    sectionTitle: "创新审计解决方案",
    sectionSubtitle: "为组织提供尖端的审计技术和全面的合规管理",
    features: [
      {
        icon: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#0991d3\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"11\" cy=\"11\" r=\"8\"/><line x1=\"21\" y1=\"21\" x2=\"16.65\" y2=\"16.65\"/></svg>",
        title: "智能分析",
        desc: "先进的动力分析能够以前所未有的准确性识别审计流程中的风险和异常情况。"
      },
      {
        icon: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#0991d3\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><line x1=\"18\" y1=\"20\" x2=\"18\" y2=\"10\"/><line x1=\"12\" y1=\"20\" x2=\"12\" y2=\"4\"/><line x1=\"6\" y1=\"20\" x2=\"6\" y2=\"14\"/></svg>",
        title: "实时报告",
        desc: "通过交互式仪表板和可定制的指标实时生成全面的审计报告。"
      },
      {
        icon: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#0991d3\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z\"/></svg>",
        title: "合规管理",
        desc: "通过自动监控和警报系统保持符合行业标准和法规。"
      },
      {
        icon: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#0991d3\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"/><circle cx=\"9\" cy=\"7\" r=\"4\"/><path d=\"M23 21v-2a4 4 0 0 0-3-3.87\"/><path d=\"M16 3.13a4 4 0 0 1 0 7.75\"/></svg>",
        title: "协作平台",
        desc: "通过集成的通信和工作流程管理工具实现审计团队之间的无缝协作。"
      }
    ]
  },
  newServices: {
    sectionTitle: "专业审计服务",
    sectionSubtitle: "根据您组织的独特运营、合规性和风险管理需求量身定制的全面审计解决方案",
    learnMore: "了解更多",
    cards: [
      {
        icon: "<img src=\"/img/3d-icons/financial.png\" alt=\"财务审计图标\" />",
        title: "财务审计",
        desc: "通过详细的运营审核和建议，优化您或您的供应商的业务流程和运营效率。"
      },
      {
        icon: "<img src=\"/img/3d-icons/it-security.png\" alt=\"IT 安全审核图标\" />",
        title: "信息技术安全审计",
        desc: "彻底评估您的 IT 基础设施，识别漏洞并确保采取强有力的网络安全措施。"
      },
      {
        icon: "<img src=\"/img/3d-icons/security.png\" alt=\"合规审核图标\" />",
        title: "合规审核",
        desc: "通过我们专业的合规审计服务确保遵守行业法规和标准。"
      },
      {
        icon: "<img src=\"/img/3d-icons/compliance.png\" alt=\"操作审核图标\" />",
        title: "运营审计",
        desc: "通过详细的运营审核和建议来优化您的业务流程和运营效率。"
      }
    ]
  },
  home: {
    banner: {
      title: "行业大脑平台",
      description: "数据驱动的智慧平台连接政府与市场，赋能产业高质量发展",
      title1: "下一代审计平台",
      title2: "通过驱动技术和实时合规性监控转变您的审计流程",
      subtitle1: "智能风险评估",
      subtitle2: "先进的分析和机器学习可在风险影响您的业务之前预测、识别和减轻风险",
      button: "开始免费试用",
      features: [
        "支持审计分析",
        "实时合规监控",
        "自动风险评估",
        "综合报告仪表板"
      ]
    },
    carousel: {
      items: [
        {
          kicker: "审计软件",
          description: "在一个互联的工作空间中，更清晰地管理审计模板、标准和执行流程。",
          metrics: [
            { value: "12+", label: "模板" },
            { value: "1-2年", label: "许可周期" },
            { value: "云端", label: "交付方式" }
          ]
        },
        {
          kicker: "合规平台",
          description: "专为现代质量团队打造，实现更简单的管控、更高效的协作和可追溯的记录。",
          metrics: [
            { value: "ISO", label: "就绪" },
            { value: "团队", label: "共享使用" },
            { value: "实时", label: "记录" }
          ]
        }
      ]
    },
    introduction: {
      title: "什么是行业大脑",
      subtitle: "以数据为中心、场景驱动、服务为导向的工业数字基础设施"
    },
    sections: {
      government: {
        title: "政府侧",
        desc: "宏观监测、政策评估、产业剖析、选址、精准服务"
      },
      market: {
        title: "市场方",
        desc: "企业洞察、竞争分析、投资匹配、供需经纪和运营支持"
      }
    },
    coreScenes: {
      title: "核心场景",
      subtitle: "从监测、评估、测绘到投资，覆盖全流程"
    },
    advantages: {
      title: "我们的优势"
    }
  },
  news: {
    title: "新闻与更新",
    items: [
      {
        plate: "公司新闻",
        title: "我们集团实现创纪录的增长",
        desc: "我们很自豪地宣布我们公司进入了一个显着的增长阶段。"
      },
      {
        plate: "新功能/更新",
        title: "多个审核步骤的自动化",
        desc: "我们的新功能增强了针对个人标准的目标导向审核。"
      },
      {
        plate: "新模板",
        title: "更多变化带来更高的效率和效果",
        desc: "我们模板的扩展使我们的客户能够涵盖广泛的标准。"
      },
      {
        plate: "信息安全与数据保护",
        title: "通过权限管理实现信息安全和数据保护",
        desc: "我们的软件确保信息安全和数据安全。审计管理的所有信息和数据均由组织保留。"
      },
      {
        plate: "新 ISO 14001",
        title: "新 ISO 14001",
        desc: "新 ISO 14001"
      }
    ]
  },
  growth: {
    title: "我们集团实现创纪录的增长",
    tags: { innovation: "创新", excellence: "卓越", global: "全球增长" },
    content: "我们很自豪地宣布我们公司进入了一个显着的增长阶段。在过去的几个月里，我们在各个业务领域都取得了重大进展——从扩大客户群和增加收入到推出创新产品和扩大团队规模。这种增长是我们令人难以置信的团队的奉献、协作和愿景以及我们尊贵的客户和合作伙伴持续支持的直接结果。"
  },
  automation: {
    title: "多个审核步骤的自动化",
    content: "我们的新功能增强了针对个别标准的目标导向审核。审计管理连续性的提高使审计人员能够直观、专业地处理审计过程。审计过程中多个步骤的自动化，考虑到计划-执行-检查-行动 (PDCA) 方法，可以显着提高审计质量并简化实施。"
  },
  variation: {
    title: "更多变化带来更高的效率和效果",
    content: "我们模板的扩展使我们的客户能够涵盖广泛的标准。这些模板是与国际专家和各种标准的第三方审核员共同开发的。这样可以根据精益管理的原则对整个审计软件进行优化设计。专业的审计管理是组织成功的关键基石。我们的审计软件的开发过程中考虑了整个供应链的整合。我们的软件和单独的模板支持提高客户审核的有效性和效率。"
  },
  security: {
    title: "通过权限管理实现信息安全和数据保护",
    content: "我们的软件确保信息安全和数据安全。审计管理的所有信息和数据均由组织保留。所使用的云基于 TISAX 和 ISO 2700X 标准。由组织控制的权限管理系统定义其他方对存储的信息和数据的访问。通过这种方式，组织可以对访问进行监管，从而使信息和数据始终保留在组织区域内。"
  },
  newiso: {
    title: "新 ISO 14001",
    content: "我们很高兴地通知您，我们已经可以为您提供新更新的 ISO 14001 审核模板。当然，旧的 ISO 14001 审核版本仍然可供您使用。对于拥有 ISO 14001 审核模板的现有客户，不会产生额外费用，并且可以使用这两个审核模板。"
  },
  coreCompetence: {
    title: "为什么选择LPT 科技公司",
    subtitle: "通过创新、专业知识和技术引领审计实践转型",
    technology: {
      title: "尖端科技",
      description: "基于先进的技术和标准，我们的解决方案为您提供更高的集成度、更高的自动化程度和精益思维，从而实现无与伦比的准确性和效率",
      pointsTitle: "创新审计管理技术",
      points: [
        "智能审核自动化，大幅提升工作效率",
        "精准识别合规风险，保障业务稳健运营",
        "基于大数据的洞察，辅助科学决策",
        "实时监控异常交易，预警潜在风险"
      ],
      features: [
        "卓越的金融服务审计",
        "医疗保健和生命科学合规性",
        "制造和供应链审核",
        "技术与软件审计",
        "能源和公用事业合规性",
        "房地产与建筑审计",
        "零售及电子商务审计",
        "政府和公共部门审计",
        "非营利组织和非政府组织审计"
      ]
    },
    experience: {
      title: "专家经验",
      description: "丰富的欧洲和国际审计经验，深入了解行业合规要求",
      globalDataTitle: "全球审计数据中心",
      globalDataDesc: "全球<span>10000+</span>官方数据源<span>10+</span>",
      statistics: [
        {
          title: "≥10",
          desc: "审核标准"
        },
        {
          title: "20.000+",
          desc: "风险指标"
        },
        {
          title: "≥12",
          desc: "审核工具"
        },
        {
          title: "55+",
          desc: "国家"
        },
        {
          title: "1.000+",
          desc: "客户"
        },
        {
          title: "25+",
          desc: "审计专家"
        },
        {
          title: "10.000+",
          desc: "审计记录"
        }
      ]
    },
    team: {
      title: "超越审计",
      description: "由资深审核专家和技术专家组成的国际化团队",
      upgradeTitle: "支持审计数据智能升级",
      capabilities: [
        {
          title: "创新审计",
          description: "利用我们审计管理软件的数字优势，从审计的角度前进"
        },
        {
          title: "专业技术团队",
          description: "通过自动化流程确保审计管理的连续性"
        },
        {
          title: "用一款软件满足标准审计要求",
          description: "我们的软件经过多家国际第三方审计师和世界各地的公司的测试和开发，涵盖了有关审计管理的多项标准的要求。从这些专业知识中发挥您的优势。"
        },
        {
          title: "不仅仅是审计",
          description: "将您的网络连接到组织的审计管理世界。设置您自己的网络访问权限要求。"
        }
      ]
    }
  },
  footer: {
    government: "中央人民政府",
    ministryIndustry: "工业和信息化部",
    ministryForeign: "外交部",
    products: "产品",
    audit: "审计",
    contentCenter: "资源中心",
    industryReports: "行业报告",
    contactUs: "联系我们",
    cityZhuhai: "珠海",
    addressDetail: "珠海市香洲区旅游路168号梅溪商业广场2栋21层2103号",
    email: "Customer Service",
    copyright: "版权所有 © 2026 幸运丹鸟（珠海）科技有限公司。版权所有。",
    icp: "粤ICP备2025411415号",
    emailHint: "请输入您的账号。"
  },
  company: {
    name: "幸运丹鸟",
    fullName: "幸运丹鸟（珠海）科技有限公司",
    description: "一家领先的科技企业，专注于提供创新的审计和管理系统解决方案，包括为本地和全球组织提供服务",
    tagline: "智能审计，合规未来",
    aboutUs: "关于我们",
    subtitle: "推动审计管理技术创新。",
    missionTitle: "我们的使命",
    missionDesc: "为全球组织提供智能、安全、高效的审计管理解决方案。",
    visionTitle: "我们的愿景",
    visionDesc: "成为数字审计合规和风险管理的全球标准。",
    galleryTitle: "LPT 的生活",
    galleryDesc: "了解我们的工作空间、团队文化和日常运营。",
    whoWeAre: "我们是谁",
    introText: "LPT致力于为全球企业提供量身定制的尖端审计管理解决方案。",
    ourHistory: "我们的历史",
    history: {
      events: [
        "成立于珠海新技术商务区",
        "于珠海横琴新商务科技区设立办事处",
        "我们在中国推出的第一个软件",
        "我们的软件在亚洲其他地区推出",
        "推出额外的审计工具",
        "启动我们的新软件项目",
        "我们感到自豪的是，我们的成长和成功引领我们在珠海市中心设立了一个拥有新技术实验室的新办公室。",
        "介绍我们的新软件管理平台",
        "未来等待着"
      ]
    },
    joinUsTitle: "加入我们的团队",
    joinUsDesc: "发现您的潜力并与我们一起成长。我们一直在寻找充满激情的人才加入我们充满活力的团队。",
    exploreJobs: "探索空缺职位",
    customersTitle: "我们的客户",
    customersDescription: "持续为用户创造独特价值",
    customerStats: {
      provinceCount: "22", cityCount: "40+", parkCount: "150+", companyCount: "10,000+",
      provinces: "省份", cities: "城市", parks: "产业园区", companies: "企业"
    }
  },
  jobs: {
    title: "空缺职位",
    intro: "LPT 公司是全球 Infinity Source Group 的一部分。由于我们的会员资格，我们可以获得广泛的资源。 LPT 总部位于中国珠海市中心。其业务领域涵盖应用程序和软件，以及专注于 IT 行业的主动咨询。 LPT正在打造一支专业化、充满活力的新型团队。我们依靠创新和富有远见的工作方法。",
    advantagesTitle: "作为我们团队的一员，我们为您提供哪些优势：",
    advantages: [
      "您可以在办公室工作，也可以在世界各地工作（没有固定的工作区域）",
      "获得最新的技术和设备",
      "各种奖金计划",
      "办公室免费水",
      "假期天数高于平均水平",
      "免费使用我们办公室的游戏区",
      "与一支雄心勃勃、专业且开放的团队合作",
      "开放、充满活力和专业的工作环境",
      "为您的家庭和工作场所提供全额付费的工作设备",
      "创新和前瞻性的项目"
    ],
    positionsTitle: "当前职位空缺",
    positions: [
      {
        title: "用户体验/交互设计师",
        overview: "负责Web、App、H5的UI设计",
        expectTitle: "我们的期望：",
        expectations: [
          "开放且以目标为导向的沟通",
          "独立、专业地工作",
          "对新的解决方案和挑战持开放态度",
          "汉语水平",
          "书面英语沟通（使用翻译软件就足够了）",
          "人机交互（HCI）设计经验",
          "使用设计语言改进设计和交互",
          "拥有在应用程序、软件和网页设计方面提供高质量解决方案的经验",
          "设计经验能力，能够通过设计方案有效传达产品意图",
          "2年以上UX设计师或交互设计师经验"
        ],
        softwareTitle: "熟悉设计相关软件和平台，例如：",
        software: [
          "兰湖",
          "菲格玛",
          "Photoshop",
          "插画家",
          "天蓝色",
          "草图",
          "远见",
          "心智",
          "维西奥",
          "或类似的"
        ],
        responsibilitiesTitle: "",
        responsibilities: []
      },
      {
        title: "营销专员",
        overview: "我们正在寻找营销专家",
        expectTitle: "我们的期望：",
        expectations: [
          "开放且以目标为导向的沟通",
          "独立、专业地工作",
          "对新的解决方案和挑战持开放态度",
          "汉语水平",
          "书面英语沟通（使用翻译软件就足够了）",
          "技术营销经验",
          "社交媒体经验",
          "拥有提供高质量营销解决方案（包括社交媒体）的经验",
          "适合旅行（如果相关）",
          "3年以上营销经验"
        ],
        softwareTitle: "",
        software: [],
        responsibilitiesTitle: "负责网络和社交媒体的外观：",
        responsibilities: [
          "营销相关网页设计",
          "社交媒体外观",
          "营销活动"
        ]
      },
      {
        title: "后端开发工程师",
        overview: "我们正在寻找一名软件开发工程师",
        expectTitle: "我们的期望：",
        expectations: [
          "开放且以目标为导向的沟通",
          "独立、专业地工作",
          "对新的解决方案和挑战持开放态度",
          "汉语水平",
          "书面英语沟通（使用翻译软件就足够了）",
          "具有提供应用程序和软件中高质量后端解决方案的经验",
          "2年以上后端开发经验",
          "熟悉RESTful API设计模式与最佳实践",
          "具备版本控制与代码审查流程的经验",
          "强大的问题解决能力和注重细节"
        ],
        softwareTitle: "如果您在上述领域或类似领域具备相关技能，那么您来对地方了。",
        software: [
          "后端API（应用程序编程接口）",
          "VUE",
          "MySQL",
          "Nginx",
          "MyBatis",
          "JavaScript",
          "Docker",
          "GitHub, GitLab",
          "PHPStorm或WebStorm",
          "Postman",
          "JSON",
          "Laravel 9或类似框架",
          "PHP 8或类似版本",
          "渐进式Web应用程序（PWA）",
          "数据结构与算法（DSA）",
          "Azure云或阿里云云经验"
        ],
        responsibilitiesTitle: "职责：",
        responsibilities: [
          "后端基础设施",
          "后端与前端云开发之间的接口",
          "后端框架",
          "API开发与集成",
          "数据库"
        ]
      },
      {
        title: "前端开发工程师",
        overview: "我们正在寻找一名软件开发工程师",
        expectTitle: "我们的期望：",
        expectations: [
          "开放且以目标为导向的沟通",
          "独立、专业地工作",
          "对新的解决方案和挑战持开放态度",
          "汉语水平",
          "书面英语沟通（使用翻译软件就足够了）",
          "具有提供应用程序和软件中高质量前端解决方案的经验",
          "2年以上前端开发经验",
          "熟悉现代Web标准、无障碍与响应式设计",
          "具备版本控制与代码审查流程的经验",
          "强大的问题解决能力和注重细节"
        ],
        softwareTitle: "如果您在上述领域或类似领域具备相关技能，那么您来对地方了。",
        software: [
          "HTML",
          "JavaScript",
          "GitLab仓库",
          "GitLab CI/CD自动化部署",
          "React",
          "Angular",
          "文档对象模型（DOM）",
          "Jest, Mocha或类似框架",
          "CSS",
          "Vue",
          "Azure云或阿里云云经验"
        ],
        responsibilitiesTitle: "职责：",
        responsibilities: [
          "前端基础设施",
          "前端与后端之间的接口",
          "云开发",
          "前端框架",
          "API开发与集成",
          "数据库"
        ]
      }
    ],
    applyNow: "提交申请"
  },
  buy: {
    hero: {
      title: "审计管理解决方案",
      subtitle: "概述您的审计管理解决方案，以提高灵活性、自动化程度和效率。"
    },
    steps: {
      badge: {
        step1: "第 1 步 / 共 6 步：选择套餐",
        step2: "第 2 步 / 共 6 步：选择语言",
        step3: "第 3 步 / 共 6 步：审核标准",
        step4: "第 4 步 / 共 6 步：审核员执照",
        step5: "第 5 步 / 共 6 步：审核订单",
        step6: "第 6 步 / 共 6 步：支付"
      },
      plan: {
        title: "选择套餐",
        subtitle: "选择您的订阅"
      },
      languages: {
        title: "选择语言",
        subtitle: "选择审计系统语言"
      },
      standards: {
        title: "审核标准",
        subtitle: "选择模板"
      },
      seats: {
        title: "审核员执照",
        subtitle: "配置团队规模"
      },
      confirm: {
        title: "审核订单",
        subtitle: "检查并付款"
      },
      payment: {
        title: "支付",
        subtitle: "完成购买"
      }
    },
    currency: {
      label: "货币"
    },
    summary: {
      projectSummary: "项目汇总",
      priceSummary: "价格汇总",
      selectedPlan: "已选方案",
      billingCycle: "订阅周期",
      year1: "1年",
      year2: "2年",
      year3: "3年",
      selectedLanguages: "已选语言",
      selectedStandards: "已选标准",
      auditorSeats: "审核员席位",
      adminSeats: "管理员席位",
      supplierSeats: "供应商席位",
      unlimited: "无限量",
      estimatedTotal: "预计总价",
      amountToPay: "应付金额"
    },
    languages: {
      title: "选择语言",
      subtitle: "选择套餐中包含的审计系统语言。",
      selectedCount: "已选择 {count} 种语言",
      limitCount: "最多 {count} 种语言",
      limitUnlimited: "不限语言数量",
      infoLimited: "当前套餐最多包含 {count} 种语言。支付前可以修改选择。",
      infoUnlimited: "企业版套餐包含所有可用的审计系统语言。",
      limitReached: "当前套餐最多只能选择 {count} 种语言。",
      minimumRequired: "请至少保留一种语言。",
      items: {
        english: "英语",
        french: "法语",
        spanish: "西班牙语",
        chinese: "中文",
        german: "德语",
        polish: "波兰语",
        czech: "捷克语",
        slovak: "斯洛伐克语",
        hungarian: "匈牙利语",
        romanian: "罗马尼亚语",
        bulgarian: "保加利亚语",
        serbian: "塞尔维亚语",
        croatian: "克罗地亚语",
        slovenian: "斯洛文尼亚语"
      }
    },
    nav: {
      prev: "上一步",
      next: "下一步",
      completePurchase: "完成购买",
      processing: "处理中...",
      purchaseSuccess: "购买成功！",
      purchaseError: "购买失败。请再试一次。"
    },
    trust: {
      secure: "256位SSL加密",
      moneyBack: "30 天退款保证",
      support: "24/7 专家支持",
      cancel: "随时取消"
    },
    plan: {
      monthly: "1年",
      yearly: "2年",
      perMonth: "年",
      perYear: "2年",
      savePercent: "节省 {percent}%",
      billedAnnually: "按年计费",
      billedForTwoYears: "按 2 年计费",
      mostPopular: "最受欢迎",
      selectPlan: "选择计划",
      selected: "已选择",
      compareFeatures: "比较所有功能",
      feature: "特征",
      noPlans: "暂无可用的套餐",
      plans: {
        starter: {
          name: "入门版套餐",
          desc: "非常适合从正式审核开始的小型团队。",
          features: [
            "1个审核员执照",
            "多种审核模板",
            "供应商门户访问",
            "一种语言",
            "在线/离线模式",
            "风险评估",
            "SSO 和高级安全性"
          ]
        },
        professional: {
          name: "专业版套餐",
          desc: "适用于具有高级审计需求的成长型组织。",
          features: [
            "多个审核员执照",
            "多种审核模板",
            "供应商门户访问",
            "多种语言",
            "企业报告",
            "在线/离线模式",
            "风险评估",
            "SSO 和高级安全性"
          ]
        },
        enterprise: {
          name: "企业版套餐",
          desc: "大型组织的完整审计治理。",
          features: [
            "多个审核员执照",
            "多种审核模板",
            "供应商门户访问",
            "多种语言",
            "企业报告",
            "企业支持",
            "在线/离线模式",
            "风险评估",
            "SSO 和高级安全性"
          ]
        }
      },
      comparison: {
        auditorSeats: "多个审核员执照",
        auditStandards: "多种审核模板",
        supplierPortal: "供应商门户访问",
        customTemplates: "多种语言",
        aiRiskAssessment: "企业报告",
        apiAccess: "企业支持",
        ssoIntegration: "在线/离线模式",
        dedicatedSupport: "专注支持",
        dataRetention: "数据保留",
        storage: "云存储",
        clientSupper: "客户门户访问",
        ssl: "SSL加密"
      },
      comparisonValues: {
        unlimited: "不限",
        sixMonths: "6 个月",
        oneYear: "1 年"
      }
    },
    standards: {
      perYear: "年",
      title: "选择审核标准",
      subtitle: "选择最适合您组织需求的审核标准模板",
      categories: {
        all: "全部",
        quality: "质量",
        energy: "活力",
        product: "产品",
        environment: "环境",
        process: "过程",
        security: "信息安全",
        medical: "医疗的",
        healthSafety: "健康/安全",
        creator: "创作者"
      },
      selectedCount: "已选择 {count} 个标准",
      moduleCost: "模块成本",
      perMonth: "月",
      included: "包括",
      free: "自由的",
      clauses: "条款",
      infoBanner: "您可以稍后在控制台中购买额外的标准、语言和许可证。",
      items: {
        iso9001: {
          fullname: "质量管理体系（ISO 9001）",
          desc: "对所有部门和行业的质量管理体系进行系统评估"
        },
        iatf16949: {
          fullname: "汽车质量管理体系（IATF 16949）",
          desc: "汽车行业质量管理体系的系统评价"
        },
        vda63: {
          fullname: "过程审核（VDA 6.3）",
          desc: "适用于所有部门和行业的过程评估程序"
        },
        vda65: {
          fullname: "产品审核 (VDA 6.5)",
          desc: "对出厂产品质量标准进行系统评价。"
        },
        iso14001: {
          fullname: "环境管理（ISO 14001）",
          desc: "环境管理体系的系统评价"
        },
        iso140012026: {
          fullname: "环境管理（ISO 14001）",
          desc: "环境管理体系的系统评价"
        },
        iso45001: {
          fullname: "职业健康与安全 (ISO 45001)",
          desc: "环境管理体系的系统评价"
        },
        iso27001: {
          fullname: "信息安全（ISO 27001）",
          desc: "信息安全管理体系的系统评价"
        },
        tisax: {
          fullname: "信息安全（TISAX ISA）",
          desc: "信息安全管理体系的系统评价"
        },
        iso13485: {
          fullname: "医疗管理（ISO 13485）",
          desc: "医疗管理体系的系统评价"
        },
        iso50001: {
          fullname: "能源（ISO 50001）",
          desc: "能源管理体系的系统评价"
        },
        'ISO-9001-2015': {
          fullname: "质量管理体系（ISO 9001）",
          desc: "质量管理体系的系统评价"
        },
        'ISO-14001-2026': {
          fullname: "环境管理（ISO 14001）",
          desc: "环境管理体系的系统评价"
        },
        'ISO-13485-2016': {
          fullname: "医疗器械管理（ISO 13485）",
          desc: "医疗器械质量管理体系的系统评价"
        },
        'ISO-45001-2018': {
          fullname: "职业健康与安全（ISO 45001）",
          desc: "职业健康与安全管理体系的系统评价"
        },
        'ISO-50001-2018': {
          fullname: "能源（ISO 50001）",
          desc: "能源管理体系的系统评价"
        },
        'ISO-27001-2023': {
          fullname: "信息安全（ISO 27001）",
          desc: "信息安全管理体系的系统评价"
        },
        'ISO-14971-2019': {
          fullname: "医疗器械风险管理（ISO 14971）",
          desc: "医疗器械风险管理过程的系统评价"
        },
        'ISO-22163-2023': {
          fullname: "铁路质量管理体系（ISO 22163）",
          desc: "铁路行业质量管理体系的系统评价"
        },
        'ISO-31000-2018': {
          fullname: "风险管理（ISO 31000）",
          desc: "风险管理框架与过程的系统评价"
        },
        customTemplate: {
          fullname: "自定义模板创建器",
          desc: "通过灵活的清单配置和自定义评分构建您自己的审核模板。"
        }
      }
    },
    licences: {
      title: "配置审核员许可证",
      subtitle: "设置审核团队的人数",
      perSeatYear: "许可证/年",
      perYear: "年",
      perMonth: "月",
      totalSeats: "用户总数",
      users: "用户",
      seatsCost: "审核员许可证",
      contactMore: "联系我们了解更多",
      auditor: {
        title: "审核员执照",
        desc: "执行审核、创建调查结果并生成报告的许可用户",
        seats: "许可证"
      },
      admin: {
        title: "额外的审计许可证",
        desc: "管理用户、权限和组织设置的系统管理员",
        includedCount: "计划中包含 {count} 个许可",
        extraSeats: "额外的许可证",
        extraLabel: "附加审核员执照："
      },
      supplier: {
        title: "供应商门户",
        desc: "所有计划均包含无限制的供应商访问权限，无需额外费用",
        unlimited: "无限制访问",
        note: "供应商活动",
        features: [
          "查看审核",
          "上传文件和证据",
          "管理行动管理",
          "接收通知"
        ]
      },
      client: {
        title: "客户门户",
        desc: "所有计划均包含无限制的客户访问，无需额外费用",
        unlimited: "无限制访问",
        note: "客户可以查看审核报告、跟踪进度并管理合规文档",
        features: [
          "客户活动",
          "跟踪审核进度",
          "查看审核",
          "管理共享文档"
        ]
      },
      planChangePrompt: "请更改计划来修改此"
    },
    order: {
      title: "查看您的订单",
      subtitle: "完成购买前检查您的选择",
      planDetails: "审核包",
      selectedPlan: "已选套餐",
      billingCycle: "计费周期",
      planPrice: "价格",
      package: "套餐",
      languagesDetails: "语言",
      standardsDetails: "审核标准模板",
      seatsDetails: "许可证配置",
      seatsPrice: "审核员执照",
      standardsPrice: "审核模板",
      promoPlaceholder: "输入促销代码",
      applyPromo: "应用",
      promoApplied: "已应用 {discount}% 折扣！",
      promoSuccess: "促销代码应用成功！",
      promoInvalid: "促销代码无效",
      promoDiscount: "促销折扣",
      orderSummary: "订单汇总",
      totalMonthly: "总计",
      vatNote: "* 价格不含增值税",
      agreePrefix: "我已阅读并同意",
      termsOfService: "服务条款",
      agreeAnd: "及",
      privacyPolicy: "隐私政策",
      agreementRequired: "请先阅读并同意服务条款和隐私政策以完成购买",
      encrypted: "加密的",
      sslEncrypted: "SSL 加密",
      licenceCount: "{count} 个许可证",
      guarantee: "30 天退款保证",
      storage: {
        title: "存储",
        desc: "存储与用量。",
        included: "包含",
        free: "免费",
        excluded: "不包含",
        payAsYouGo: "按需付费"
      },
      termsContent: [
        "幸运丹鸟（珠海）科技有限公司协议、条款和条件",
        "LPT“私人有限责任公司”公司的协议、条款和条件我们欢迎您访问我们的网站、设施、平台、软件、应用程序等。 LPT（以下简称“LPT”“幸运丹鸟（珠海）科技有限公司”）及其附属公司（统称“我们”、“我们的”或“我们”）。这些协议、条款和条件适用于本网站、我们的任何软件或应用程序、我们的任何网站或我们的第三方网站、软件和应用程序（在线或离线），但不适用于我们的任何其他产品或服务，除非我们另有明确说明（例如在其他网站、我们的软件或我们的移动应用程序上包含指向这些协议、条款和条件的链接）。于 2026 年 4 月 1 日修订的条件重要提示 – 在接受这些协议之前，请仔细阅读这些协议、条款和条件，然后保存这些协议、条款和条件，并将其与所有确认电子邮件、短信、消息、附加条款、隐私政策、其他政策等一起存储；与您使用平台和/或设施和/或软件和/或应用程序相关的等。我们不会将与您的合同归档，因此请保存它作为您的记录。这些协议、条款和条件可能会发生变更（如下所述）。通过点击“注册”或“登录”或“提交”或“同意”或任何其他按钮和/或使用设施（该术语定义如下），您同意受本合同的约束。在您（定义见下文）点击“提交”或“我同意”后，或者当您使用这些设施时，(a) 您、最终用户（“您”）和 (b) 幸运丹鸟（珠海）科技有限公司（在公司注册处注册，注册号为 91440400MACD90ME4A，注册地址为 02, 21 号楼）之间就这些协议、条款和条件签订了具有法律约束力的协议。编号。珠海市香洲区绿友路168号美溪商业广场2103 LPT 根据情况被定义为“我们”、“我们”或“我们的”。我们应被视为受中国法律监管。我们通过网站、软件和/或应用程序以及我们提供的任何其他在线或移动平台（每个单独的网站称为“平台”）提供设施，您可以在这些平台上使用您的帐户（设施）访问我们的设施，定义如下。如果您对设施或我们执行的任何其他活动的任何结果有任何投诉、索赔或争议，您应首先根据我们的规定与我们联系。协议、条款和条件。",
        "这些协议、条款和条件连同隐私政策、所有附加规则或政策以及在平台和/或软件和/或应用程序上发布并在平台、网站、软件或应用程序上通知您的任何其他附加规则、政策、条款和其他内容，特别涉及并管辖任何特定事件、软件、促销或其他内容，构成您和我们之间具有法律约束力的协议（“协议”）。在向您通知协议规则或条款的任何变更后，您可以选择根据我们的协议、条款和条件终止。您应仔细阅读所有这些文件，因为每一份文件均构成您与我们之间具有法律约束力的协议的一部分。如果这些协议被翻译成其他语言，则在翻译与其他语言版本之间存在任何冲突的情况下，以中文版本为准。请注意，如果这些协议、条款和条件以及这些协议、条款和条件中提及的其他文件之间存在任何冲突，则应以这些协议、条款和条件为准。通过点击“注册”或“登录”或“提交”或“同意”或任何其他并接受这些协议、条款和条件，即表示您承认并接受这些协议。访问和使用我们的设施受这些协议的约束。如果您对这些协议有任何疑问，我们鼓励您寻求独立的法律建议。设施和交互功能可能会根据您用来访问它们的平台、软件或应用程序或其他平台的不同而有所不同。请您注意我们的隐私政策，其中描述了我们如何处理和保护您的个人信息。接受这些协议、条款和条件，即表示您承认并接受隐私政策和所有其他内容。 软件、应用程序或网站设施软件、应用程序或网站设施是我们通过以下平台提供的设施，例如（但不限于）：lpt-software.cn 以及我们不时提供的任何其他平台和/或软件和/或应用程序。如果您正在使用或打算使用软件、应用程序或网站设施，您必须按照我们的协议、条款和条件进行操作。",
        "合同依据我们不承认任何与我们的一般条款和条件相冲突或背离的客户条件，除非我们明确书面同意其有效性。我们默示提供的交付或服务或类似行为并不意味着同意客户的冲突条件。合法交易（交付、计费等）由 LPT 以自己的名义为第三方账户进行。 订单和合同的签订 在线商店中展示的产品、软件、应用程序等并不代表我们具有法律约束力的要约，而是不具约束力的在线目录（以下简称订单要约）。客户可以首先将网上商店的产品、软件、应用程序或类似产品无义务地放入购物车，并在提交订单之前随时确保输入正确。通过单击“购买”按钮，客户对购物车中包含的商品、软件、应用程序或类似产品下达具有约束力（应付）的订单（报价）。发送订单后即确认收到订单，并不构成对合同的接受。我们可以在 10 个工作日内通过发送确认或其他方式接受客户的订单。我们仅接受将我们的商品、软件、应用程序或类似产品用于商业用途，而不是私人用途。特此拒绝消费者签订合同。消费者保护法规不适用。合同将不会被保存。交付如果可用，订购的产品、软件、应用程序、书籍或类似产品将立即交付（在申请后大约 10 个工作日内），提供下载或提供相应的在线访问。如果产品、软件、应用程序或类似产品不再有库存、缺货或可用或因其他原因而被阻止，我们保留不执行订单的权利。在这种情况下，客户将被告知不可用。更新如果 LPT 提供了包含更新的相应服务、产品、软件、应用程序等，则可以付费或免费提供这些服务、产品、软件、应用程序等。这些不包含任何正确性或完整性声明，也不代表 LPT 具有约束力、法律或类似义务。",
        "第三方提供商客户有时有机会访问第三方的内容。为此，它可能会被重定向到服务器、云或类似的第三方提供商。如果第三方内容产生额外费用（例如按文档付费或类似费用），第三方提供商将通知客户。如果第三方未提供此信息，客户就无法对 LPT 提出任何合法或类似的索赔。如果客户使用我们的服务、产品、网站、软件、应用程序或类似 SaaS，则适用“SaaS（软件即服务）”一章。观看期/测试阶段如果提供或指定观看期/测试阶段，则客户在首次购买时将具有依赖于优惠的观看期/测试阶段。测试权从订单发出之日开始。如果客户决定长期使用该软件，如果明确提及，他可以继续直接使用输入的所有数据。收到订单后，他会在其注册帐户中收到发票。这仅在测试期结束后到期。如果客户决定不接受 LPT 的服务、软件、应用程序或类似服务，则在查看期/测试阶段结束后，这些服务、软件、应用程序或类似服务将自动停用或类似。 价格和付款条款价格我们的在线商店、网站、软件、应用程序或类似服务中的价格为净价加上法定税费和任何产生的运输费用。使用第三方服务（例如但不限于SaaS等）的费用不包含在我们的价格中，客户将单独付费。下订单前，包含税费和运费的总价会在订单概览页面（购物车）上向客户显示。如果由 LPT 提供，客户可以选择购物车中的不同付款方式。合同签订时付款。付款方式和到期日我们提供多种付款方式可供客户选择。各自的到期日是指定的或基于各自的法律规定。订单、发票和提醒将相应地发送给客户（例如但不限于电子邮件、帐户或类似方式）。",
        "延迟付款和阻止访问如果延迟付款，LPT 有权阻止、删除或类似地访问我们的服务、产品、网站、软件、应用程序或类似内容。 LPT没有指定阻止或删除的时间段。在这种情况下，客户仍有义务支付约定的价格。在这种情况下，LPT 有权要求支付全部约定的年度金额，并将未决索赔移交给收债机构或类似机构进行起诉。特别是，客户必须承担追债服务提供商或类似机构产生的费用。如果由于客户原因导致 LPT 服务的访问被阻止、删除或类似，则客户必须承担阻止费用、滞纳金和类似费用。此外，在这种情况下，客户无权或主张向 LPT 开具任何已发生或可能发生的费用或任何类型的类似费用的发票。在这种情况下，我们保留永久拒绝或阻止客户访问或使用我们的服务、产品、网站、软件、应用程序或类似内容以及（立即）删除其帐户的权利。如果 LPT 的决定规定，一旦未决索赔得到解决，封锁、封锁或类似行为将被解除，该解除可能需要几个工作日。 价格调整和其他调整 我们有权在合同期限内对成本、价格、报价和类似项目进行调整。这些调整将通过电子邮件、网站、帐户、软件、应用程序或类似方式传达给客户。通知期限不受此影响。保留权客户无权扣留付款，除非他有权从同一合同关系中获得法定保留权。仅当所抵销的索赔无争议或已合法成立时才允许抵销。未经授权的退货费用必须由客户承担。 送货费用如果因送货产生费用，这些费用将在订单中向客户收取，并且必须由客户承担。这些费用可能因交付方式和交付而异。合同期限和终止合同期限最短合同期限是在订阅、套餐、服务、产品、软件、应用程序或类似内容中商定的。除非宣布终止，否则合同将自动延长。",
        "终止对于订阅、套餐、服务、产品、软件、应用程序或类似产品，可以在期限结束时终止合同，除非合同包含特别商定的通知期。在任期的最后一天之前可以宣布终止。合同终止后仍收到的任何交付的货物必须退回。合同结束后，LPT 没有义务保存或保留数据、信息或任何类似内容。通过终止合同，客户解除 LPT 的任何存储、存档或类似义务。客户还授权 LPT 执行任何类型的删除。终止形式任何类型的终止都必须使用 LPT 指定的终止类型/形式以书面形式作出。在大多数情况下，这是使用表格完成的。 因重要原因终止双方因正当理由终止的权利不受影响。特别是，如果出现以下情况，我们有权在不另行通知的情况下特别终止本合同：  客户在一段时间内拖欠付款，  未经我们事先同意，用户帐户被转让或访问数据被第三方访问，或者  客户违反了本合同项下的其他义务。威胁拒绝违约行为的最后期限的必要程度取决于适用的法律。如果法律没有规定，LPT 有权立即特别终止，无需设定期限。 我的帐户和访问我的帐户注册客户可以通过客户帐户自行执行所有活动。除其他外，这为客户提供购买服务、软件、产品、应用程序或类似产品的服务。注册使用客户帐户需要注册。法人实体的注册只能由必须指定姓名的授权自然人进行。如果有客观原因，例如，我们可以拒绝接受注册。提供了不正确的信息或担心可能无法履行付款义务。我们还保留拒绝注册且无需说明理由的权利。",
        "版权和商标LPT 徽标一词和 LPT 使用的任何其他标记是 LPT 或其子公司或关联公司之一或其许可方的商标、服务标记和/或商号。此外，LPT 使用的所有其他材料，包括但不限于软件、图像、图片、图表、照片、动画、视频、音乐、音频、文本（以及其中任何一项的任何知识产权），均归 LPT 或其子公司或相关 LPT 公司和/或许可方所有，并受版权和/或其他知识产权的保护。您不获得此类版权材料或商标或服务标志的任何权利，并且未经 LPT 书面许可不得使用它们。版权/使用权使用权的范围客户仅被授予在使用合同约定期限内的有限时间内对我们的服务、网站、软件、产品、应用程序或类似产品的不可转让和非独占的使用权。使用权仅限于下述用途。服务、网站、软件、产品、应用程序或类似使用权范围（使用权）客户有权在合同约定的范围内（购买的许可证数量、使用权期限）使用我们的服务、网站、软件、产品、应用程序或类似范围。我们的服务、网站、软件、产品、应用程序或类似产品每个许可证只能安装一次并由一个人使用。如果签订网络版本/多个许可证的合同，客户有权由与购买的许可证数量相对应的人数使用我们的服务、网站、软件、产品、应用程序或类似产品。使用权的期限由相应的要约决定。",
        "SaaS（软件即服务）我们还在我们的一些服务、网站、软件、产品、应用程序或类似服务中使用 SaaS。因此，客户有责任确保兼容的访问和所需的硬件和软件环境。数据和信息的存储可以由第三方提供商存储。通过使用我们的服务、网站、软件、产品、应用程序或类似产品，即表示客户接受这些第三方提供商的条款和条件。客户有责任在使用我们的服务、网站、软件、产品、应用程序或类似产品之前查看这些条款和条件。使用第三方服务的费用在“价格和付款条件”一章中定义。如果发生故障或类似情况，客户必须直接与我们的客户服务共享此信息。欲了解更多详情，请参阅“切换点和可用性”和“服务级别和支持”章节。客户只能按照合同使用合同涵盖的服务。仅可传输不含计算机病毒或其他有害代码的数据。软件或与 SaaS 解决方案的使用相关的任何其他技术或方法的使用方式均不得损害其操作、安全性或可用性。 Lexware Office 可通过标准 Web 浏览器访问。如果您使用其他技术，例如附加组件、插件、VPN 或类似技术，可能会导致 Lexware Office 不可用或仅部分可用。在这种情况下，我们对可用性不承担任何责任。禁止使用非通过公共 API 或合作伙伴 API 提供且未记录的接口。客户只能在合同约定的范围内并遵守适用的准则（条款和条件）使用合同涵盖的服务。如果客户使用 SaaS 解决方案，LPT 的责任。每个日历年的 LPT 责任仅限于签订合同时的可预见损害，每个日历年所有索赔的总额最高等于客户在该日历年支付的报酬的 60%。此责任限制也适用于数据丢失或数据损坏的情况。",
        "AI（人工智能）功能或 AI 的合同使用如果 AI 功能由 LP 实施，则客户有权使用该 AI，而不会违反任何适用的法律或监管要求。此外，只有在符合我们的条款和条件的情况下才允许使用人工智能功能。严格禁止使用存在风险的人工智能。风险类型没有区别。作为人工智能功能一部分的内容过滤器或安全系统不得被客户停用、规避、破坏或损害。这还包括直接或间接的提示注入或对抗性输入。此外，客户知道，该输出并不构成个别情况下的法律建议，并且不能取代相关专业人士（例如但不限于审计专家、税务顾问、律师等）的建议。使用人工智能的结果和后果完全由客户负责。 LPT 对人工智能应用所产生的使用、后果或结果不承担任何责任。这还包括有关适用的数据保护法、财产权和类似法律的要求和法规。客户应在第一时间要求时向我们赔偿并确保我们免受因使用人工智能功能或其授权用户使用人工智能功能而引起的所有第三方索赔（包括其用户的索赔）。这包括法庭费用和法律费用。客户无权向 LPT 索取法律或其他赔偿。 使用目的客户有权仅出于自己的目的使用我们的服务、网站、软件、产品、应用程序或类似产品。不允许代表第三方免费或付费使用我们的服务、网站、软件、产品、应用程序或类似产品并将其传递给第三方。",
        "安装数量授权仅限于所选服务、网站、软件、产品、应用程序或类似内容可以在我们描述的范围内使用。客户无权在其设备上或更大范围内安装、复制或比较我们的服务、网站、软件、产品、应用程序或类似内容。任何出于类似目的的复制或滥用都将导致刑事和法律后果。此外，客户不得通过复印或缩微胶片、电子备份或服务、网站、软件、产品、应用程序或类似产品和/或相关文档使用的任何其他方法复制服务、网站、软件、产品、应用程序或类似项目或组件、所提供的图像、手册、随附文本或类似项目或相关文档，不得分发、出租、向第三方授予分许可或以任何其他方式向第三方提供。客户无权将访问代码和/或密码以及其他信息、数据或类似项目用于服务、网站、软件、产品、应用程序或类似项目，或者用于连接到服务、网站、软件、产品、应用程序或与此相关的类似项目的数据库访问将被传递给第三方。客户无权更改、修改、改编、反编译或类似的服务、网站、软件、产品、应用程序或类似和/或相关文档的全部或部分。版权和类似内容",
        "版权我们的服务、网站、软件、产品、应用程序或类似产品的信息库、数据库、云和类似物（在线和离线）均受版权保护。此外，诸如但不限于清单、文件、文档信息和类似物品等内容均受版权保护。我们的服务、网站、软件、产品、应用程序或类似产品均受版权保护，并受相应版权法的约束。客户有权将其用于既定目的的商业目的。如果实际使用不合理地损害我们的合法利益或我们怀疑这一点，我们有权限制或阻止访问。这尤其适用于基本组件的复制、分发或公开复制，或者重复和系统性的复制、分发或公开复制，以及使我们的服务、网站、软件、产品、应用程序或类似组件及其无关紧要的组件可供访问。我们的服务、网站、软件、产品、应用程序或类似物的所有版权、使用权和其他知识产权（在线和离线）均归我们所有，作为所有使用权和财产权的所有者。使用权范围（使用权）客户有权访问我们的服务、网站、软件、产品、应用程序或类似物的信息库、数据库、云和类似物（在线和离线），这些信息用于这些目的和遵守商定的法规、准则和协议是合适的。使用权的期限由合同关系的协议确定。",
        "使用限制客户承诺仅将我们的服务、网站、软件、产品、应用程序或类似物的信息库、数据库、云和类似物（在线和离线）用于其自身目的，并且不授予第三方免费或收费的单独访问权限，以启用我们的服务、网站、软件、产品、应用程序或类似物的信息库、数据库、云和类似物（在线和离线）。我们的服务、网站、软件、产品、应用程序或类似物的信息库、数据库、云和类似物（在线和离线）只能由一个人或每个许可证由 LPT 定义的人数使用。客户承诺未经我们全部、部分或类似形式的书面同意，不会复制、修改、改编或向第三方提供信息、数据或类似信息、数据或类似信息、网站、软件、产品、应用程序或类似信息，以便他们能够在未经许可用户的情况下获得访问权限（间接使用）。此外，未经我们书面同意，不得将任何不在服务、网站、软件、产品、应用程序或类似用途范围内的信息、数据或类似项目传输给第三方。使用限制仅允许在我们支持的服务、网站、软件、产品、应用程序或类似用途上使用。禁止客户更改服务、网站、软件、产品、应用程序或类似项目上的版权声明、标记、商标和/或所有权信息。更新的保证我们的服务、网站、软件、产品、应用程序或类似项目会按照预期的谨慎定期创建、修订和更新。尽管要小心谨慎，但在使用服务、网站、软件、产品、应用程序或类似项目时，应始终确保法律的变更或其他变更可能需要进行修改或类似的修改。投诉必须立即以书面形式提交给 LPT（客户服务）。客户无权就此向 LPT 要求任何赔偿。 补救权客户可以在法定保修期内要求维修。如果我们不愿意或无法进行维修或类似的工作，或者由于其他原因而失败，客户有权自行决定要求撤销合同。",
        "责任和类似责任如果因疏忽而违反某项义务，而履行该义务对于正确执行合同至关重要，并且违反该义务会危及合同目的的实现，我们的责任仅限于可预见的和相关交易类型典型的损害金额。利润损失或类似的利润损失和浪费的费用或任何类似的责任被排除在外。免责声明LPT 不承担任何进一步的责任或任何责任数据备份责任保护必要的信息、数据或类似的服务、网站、软件、产品、应用程序或使用它们所需的类似用途的范围。 LPT 没有义务完全保护信息、数据或任何类似内容。个人责任上述责任限制也适用于 LPT 的员工、代表和机构、合作伙伴或类似人员的个人责任。损害索赔客户不能向 LPT 提出损害索赔，疏忽情况除外。保密性原则客户也有义务处理根据本合同向他提供的信息作为在合同关系期间获得的有关技术、商业、组织或类似性质的保密知识或类似信息，并且在合同期间和合同终止后，未经 LPT 事先书面同意，没有义务不利用、使用或向第三方或类似人员提供此类信息。客户确保员工、子公司、合作伙伴或类似人员遵守适当的保密义务。该信息的使用仅限于执行本合同。一旦发现任何未经授权的披露或可能丢失机密信息或类似信息，客户应立即书面通知 LPT。",
        "披露的法律义务如果客户根据法律、法院或官方命令有义务披露信息，则披露禁令不适用。然而，在这种情况下，有义务披露的客户有义务在信息披露之前通知LPT，以便LPT有机会针对此类披露进行辩护并阻止或限制这种披露。有披露义务的客户将尽最大努力确保所有要披露的机密信息均由下令披露的官方机构进行保密处理。 保密性的延续即使在本合同终止后，客户在本合同中的保密义务仍然无限期地保留。如果这方面有某些法律规定，则这些应用程序可以。合同接管我们有权在通知后将本合同关系中的权利和义务全部或部分转让给第三方。本公告将通过 LPT 的通信渠道之一（例如但不限于电子邮件、帐户、网站、软件、应用程序等）发布。 交接点和可用性对于与互联网或其他连接选项的连接，为使用我们的服务、网站、软件、产品、应用程序或类似内容而提供或维护网络连接，以及在客户端采购和提供用于互联网或其他连接选项的网络访问组件，客户必须自行注意。客户对我们的服务、网站、软件、产品、应用程序或类似产品的任何此类故障、中断、不使用或类似情况承担全部责任。 服务水平和支持在某些情况下，可以在工作时间之外（大约 365 天、24 小时）使用我们的服务、网站、软件、产品、应用程序或类似产品，但无权这样做。如果由于紧急技术或类似原因，在营业时间内异常需要进行维护工作，导致我们的服务、网站、软件、产品、应用程序或类似项目在此期间无法使用，我们将在可能的情况下及时通知客户。本公告将通过 LPT 的通信渠道之一（例如但不限于电子邮件、帐户、网站、软件、应用程序等）发布。LPT 和/或合作伙伴可以为客户提供支持，并且可以通过 LPT 的通信渠道（例如但不限于电子邮件、帐户、网站、软件、应用程序等）与客户联系。 LPT有权访问",
        "支持所需的数据和信息。在大多数情况下，维修由 LPT 和/或合作伙伴免费进行。如果客户需要支付故障排除费用，LPT 将在修复之前以书面形式通知客户以及可能产生的任何费用。关于故障排除，LPT 和/或 LPT 的合作伙伴会分析和纠正错误、故障、中断等。对于这些问题的成功解决，不提供任何保证或持久性保证。客户可以通过客户服务向 LPT 报告可重现的错误。 LPT 对信息或数据的丢失或类似丢失不承担任何保证，并且在这种情况下不能受到法律起诉。消除错误、故障、中断或类似问题的响应时间是迅速的，并且取决于具体情况。因此没有给出反应时间的详细估计。客户无权要求纠正错误、故障、中断或类似项目。 LPT 和/或合作伙伴会对这些进行分析、评估并进行相应处理。 LPT 和/或合作伙伴没有义务披露有关纠正错误、故障、中断或类似情况的详细信息。除其他外，这有助于安全，而安全可能会因披露而导致潜在风险。合作义务客户必须及时、全面地提供执行合同服务所需的合作。合作义务尤其包括客户的以下活动：•必须遵守所有适用的法律和其他法律法规。禁止向我们的服务器传输违反法律规定或侵犯第三方财产权或版权或其他第三方权利的数据或内容。如果仍应传输这些内容，则必须考虑这些一般条款和条件中的相关条件。•如果出现错误消息，所有与故障排除相关的文档、协议和其他信息必须立即提供给我们。•客户有义务定期参加应用程序适当的培训课程（如果有或提供）或以其他方式获取使用我们的服务、网站、软件、产品、应用程序或类似内容所需的知识。•只有不含计算机病毒或其他有害代码的数据才可以传输给我们。客户对此承担责任。•不得使用与我们的服务、网站、软件、产品、应用程序或使用相关的任何软件或其他技术或程序。",
        "数据、信息和类似信息的屏蔽如果第三方通过客户向我们传输、转移、移交或类似的数据、内容、信息或类似内容声称对 LPT 存在法律违规或类似行为，如果第三方已明确证明存在违法行为，LPT 有权使用相应的数据、内容、信息或类似信息来暂时屏蔽。在此情况下，LPT将要求客户在合理期限内停止侵权行为或证明内容的合法性。如果客户不遵守此要求或未充分遵守此要求（由 LPT 或立法机关酌情决定），我们有权在不损害其他权利和索赔的情况下，出于正当理由终止合同，而无需遵守通知期。如果客户对违法行为负有责任，他也有义务赔偿由此造成的损失，并且必须在首次提出要求时赔偿 LPT 和/或其合作伙伴免受任何第三方索赔。保留进一步的权利。更改、调整或类似行为LPT 和/或合作伙伴有权随时进一步开发、更改、改编、补充、删除、出售、终止我们的服务、网站、软件、产品、应用程序或类似项目的全部或部分内容或类似部分。这些条款生效后将成为与客户签订的合同的一部分。这不需要向客户发出任何公告、报告或类似内容。如果向客户发出公告、消息或类似信息，将通过 LPT 的通信渠道之一（例如但不限于电子邮件、帐户、网站、软件、应用程序等）完成。定制要求/请求如果客户要求进行特定调整或类似的操作，可以通过客户服务提出要求。 LPT 没有义务接受或实施客户特定要求或类似要求。 LPT 对这些请求进行相应的分析和评估。如果LPT决定实施该请求而客户需要承担费用，则在实施前将与客户签订书面协议。这些一般条款和条件中定义的条件适用于此类调整、开发和类似项目（例如但不限于版权、使用条款等）。",
        "存在缺陷和类似其他缺陷时的权利在非合同履行的情况下，LPT 和/或合作伙伴有权获得补充履行，并且在法律要求的情况下有义务这样做。如果在合理期限内未提供补充履行，可以设定一个合理的宽限期并威胁拒绝。如果该期限届满后仍未成功，客户有权终止合同，恕不另行通知。客户可以向 LPT 索赔最高可达合同成本的损失（因为缺陷是合法报告的）。除非有这方面的合法索赔，否则不会提出进一步的损害索赔。客户对此类缺陷的索赔将在 6 个月后到期，除非有法律规定。第三方的产权侵犯产权的后果如果按照合同使用我们的服务、网站、软件、产品、应用程序或类似产品导致侵犯第三方的工业产权和版权，并且第三方因此类违规行为向客户提出索赔，LPT 和/或合作伙伴将根据我们在您的选择承担责任。自费•获得使用服务、网站、软件、产品、应用程序或类似产品的权利，或•返工、调整、更改或类似我们的服务、网站、软件、产品、应用程序或类似产品，以便不再违法，并具有与客户签订的合同约定的可接受的特征。如果此类应用方法无效或被第三方拒绝，LPT 将在应用程序适当的框架内并自行决定为客户辩护。如果客户不存在本协议含义内的过错或与 LPT 或合作伙伴类似的过失，并且可以证明这一点，LPT 将不会向客户提出任何损害索赔。",
        "客户的信息义务如果第三方声称其侵犯知识产权，客户有义务立即通知我们。如果我们之前已告知我们不会为客户辩护，则客户仅有权采取措施，特别是在法庭上为自己辩护，或满足有保留的第三方的法律索赔。责任无论签订合同时存在的缺陷如何，均排除损害赔偿责任。在线培训注册的特殊条款和条件客户有机会通过我们的服务、网站、软件、产品、应用程序或类似。如果在线培训已被预订满或因其他原因无法进行，我们将通过 LPT 的沟通渠道之一（例如但不限于电子邮件、帐户、网站、软件、应用程序等）向客户通知这一情况。发票在培训完成后立即开具，客户必须在发票上规定的期限内付款。 取消在线培训客户有权在在线培训开始前 7 个日历日内免费取消在线培训。客户随后取消的情况除外。",
        "取消或类似的在线培训 由于参加人数不足或其他我们无法预见的原因（例如但不限于演讲者突然患病、不可抗力等），LPTLPT 保留随时取消、取消或类似在线培训的权利。 LPT 没有义务对此给出理由。 LPT 将通过 LPT 的通信渠道之一（例如但不限于电子邮件、帐户、网站、软件、应用程序等）将此情况告知客户。在这种情况下，在线培训将不收取任何费用。客户无权要求替代日期或任何类似的东西。如果在合同期内预订了培训课程，但仅在终止的合同期结束后才进行，则不能再参加。SUBJECT TO CHANGELPT 有权在在线培训之前、期间或之后进行必要的内容、方法、组织或类似的更改、调整、偏差和类似的事情。此外，我们有权随时更换演讲者或类似演讲者，而无需给出或沟通理由。作为进一步培训的一部分提供的文件、信息或类似项目是根据我们的知识和知识水平创建的。不承担对数据、内容、信息或类似内容的正确性、时事性、完整性、质量或可比性的责任和保证。",
        "保留所有权和使用权保留对所有交付的教材、数据、信息和类似物品的不受限制的所有权，直到客户完全履行所有付款义务。客户获得教材、数据、信息和类似物品的非专有使用权，不受时间和空间的限制。不允许传递给第三方，即人员、同事、客户员工、合作伙伴或类似人员，或公开分发或提供教材、数据、信息或类似材料。特别是，禁止在可公开访问的互联网门户（共享）或类似网站上发布音频或视频数据、数字演示或脚本等。在线培训的教材、数据、信息或可比内容的编辑、修改、改编或可比同样适用。教材、数据、信息和类似项目，特别是记录和文件以及类似项目，在合同期限结束前可供客户使用。未经LPT事先书面同意，客户无权在本地存储教材、数据、信息或类似物品。如果客户在合同结束时合法保存了教材、数据、信息和类似物品，则该权利在合同结束时到期，必须由客户完全删除，而无需 LPT 单独提出请求。客户执行完全删除后，客户必须以书面形式通知LPT。即使客户提出书面请求，也不允许客户进行不完全删除。",
        "客户服务客户服务代表任何人（无论是否为客户）与公司之间的基本联系点，因此您的所有疑问都应向客户服务提出。请记住，客户服务对您的疑问给予应有的重视和考虑。我们尽力尽快回答您的疑问。如果您有任何疑问，请查看我们的协议、条款和条件。客户服务电子邮件地址：Customer Service我们的协议、条款和条件的修改我们保留通过在我们的网站和/或平台和/或软件和/或移动应用程序或我们的其他人上发布修订内容随时更改我们的协议、条款和条件的权利。此类更改将在发布或上传后生效。 无效或不可执行如果本协议的任何条款变得或被认定为无效或不可执行：本协议的所有其他条款仍具有完全效力；无效条款或不可执行条款应被视为自动修改并被有效或可执行条款取代，该条款在经济上尽可能实现无效和不可执行条款的目的和意图。同样的规则适用于非故意遗漏（如果有）。",
        "隐私政策（COOKIE 和数据保护）我们欢迎您访问我们的网站、设施、平台、软件、应用程序等。 LPT（以下简称“LPT”、“幸运丹鸟（珠海）科技有限公司”）及其附属公司（统称“我们”、“我们的”或“我们的”）尊重我们用户的隐私，并致力于保护用户的隐私。本隐私政策适用于本网站、我们的任何软件或应用程序、我们的任何网站或我们在第三方网站、软件、服务和应用程序以及收集（在线或离线）并提供给我们的信息，但不适用于我们的任何其他产品或服务，除非我们另有明确说明（例如在我们的其他网站或我们的软件或移动应用程序上包含指向本隐私政策的链接）。您的 IP 地址的存储我们存储您的网络浏览器传输的 IP 地址严格用于识别、限制和消除对我们的网站、软件或移动应用程序的攻击，或者用于我们的服务、设施和我们或我们可能已接受的任何第三方的其他攻击。我们会在提供我们的服务或我们的其他人所需的时间内存储您的 IP 地址，并且删除不会与任何保留期限冲突。",
        "收集您的个人信息我们或相关的指定服务提供商收集您在我们的网站、软件、移动应用程序、第三方网站、软件和应用程序（在线或离线）上自愿提供的个人信息和数据，其中可能包括您的姓名、地址、电子邮件地址、联系信息、信用卡号、账单信息、密码、年龄等。例如，如果您在我们的网站、软件、移动应用程序上注册，我们或指定服务提供商会收集此类信息应用程序等。当您使用我们的网站、软件、移动应用程序、服务、产品或注册我们的帐户时，我们会收集您向我们提供的个人信息，这可能包括名字和姓氏、出生日期、信用卡信息、用户名和密码、年龄和身份证明、帐单地址、家庭住址、电子邮件地址、电话号码或其他联系信息。此外，我们还收集有关您的设备和平台的技术信息，例如管理和流量信息，包括但不限于：源 IP 地址、访问时间、访问日期、设备类型、访问的网页、语言使用、您的位置、漫游轨迹、软件崩溃报告和使用的浏览器类型。该信息对于服务和其他服务的提供和质量至关重要。我们收集您的公开个人资料，包括您在喜欢、发布或以其他方式与我们的社交媒体页面或其他服务和产品互动时向我们提供的姓名、照片和其他信息。当您联系我们或以其他方式与我们互动时，我们可能会保存通信记录，包括通过电子邮件、信件、短信 (SMS)、在线、软件、消息应用程序（例如 Whatsapplications 和 Skype）、电话或我们网站上的实时聊天功能等。我们还从第三方数据库收集其他信息，以遵守我们的法律和监管义务。我们还可能从在线供应商和服务提供商（例如金融和共享流动性服务）以及从第三方供应商合法获取的客户列表中收到您的个人信息。当您通过使用我们的服务、网站、软件、移动应用程序或产品向我们提供此类信息时，我们可能会收集有关您的其他信息。如果您不提供某些个人信息，我们的网站、软件或移动应用程序上的所有功能将无法使用。",
        "您提供的有关其他人的信息请不要提供有关其他人的任何信息，除非您获得授权这样做并同意根据本隐私政策使用、披露和转让所有信息。如果您提交有关他人的此类信息，则您声明并保证您已获得这样做的授权，这包括您已收到您提供信息的人的授权，以及您提供这些信息的人的授权，并且该人已同意根据本隐私政策使用、披露和转让所有信息。请注意有关将第三方内容上传到我们的网站、软件、移动应用程序、服务、产品或其他的规则。请注意，本隐私政策将由您和我们双方商定，并将构成您与我们协议的一部分。我们可能会定期更改本隐私政策，并强烈建议您定期重新访问本隐私政策。请注意以下条款和条件：我们不对您在我们的网站、软件、移动应用程序、服务、产品或其他上发布的任何第三方内容主张任何所有权。您同意您对您使用您的用户 ID 发布的任何第三方内容承担全部责任。您特此授予我们非独占、免版税、全球性、永久的许可（包括分许可的权利），以便我们使用（并制作我们认为必要的副本），以便于在我们的网站、软件、移动应用程序、服务、产品和其他内容上发布和存储您的第三方内容，或与现在已知或以后开发的所有媒体中的任何促销活动相关。您向我们保证，您拥有授予上述 2) 中的许可的充分权力和权限，并且您发布的第三方内容不会侵犯任何第三方的知识产权、其他专有权或公开权或隐私权；不会违反任何法律、法规、条例或法规；不会诽谤、商业诽谤、非法威胁或非法骚扰；不会淫秽或色情，并且不包含儿童内容色情内容；不违反任何有关不正当竞争、反歧视或虚假广告的法律；不构成任何类型的禁止第三方",
        "内容并且不包含任何旨在破坏、有害干扰、秘密拦截或侵占任何系统、数据或个人信息的病毒、特洛伊木马、蠕虫、定时炸弹、取消机器人或其他计算机编程例程。您同意支付因您在我们的任何网站、软件、移动应用程序、服务、产品上发布任何第三方内容而欠任何第三方的所有特许权使用费、费用或任何其他款项您承认以下内容构成（但不限于）禁止的第三方内容： 第三方内容：具有攻击性，宣扬针对任何 LPT 或个人的种族主义、偏执、仇恨或任何形式的人身伤害，或者剥削、骚扰或主张骚扰任何人； 构成您明知是虚假或误导性的信息，或宣扬非法活动或辱骂、威胁、淫秽、诽谤或诽谤的行为； 包含裸露、过度暴力或冒犯性主题或任何此类内容的链接；  向十八岁以下或您所在管辖范围内其他较高或较低的最低法定年龄以下的任何人索取个人信息； 包含对任何人构成或造成隐私或安全风险的信息；  包含他人受版权保护的作品的未经授权的副本；  包含您未经他人同意而发布的他人照片或视频。您的个人信息的使用和信息使用我们将这些信息用于经过深思熟虑的商业目的，这也使客户受益，其中包括以下部分或全部以及可能更多目的： 提供我们的服务和产品 帮助和支持改进我们的服务和产品 开发新服务和产品 与您和客户沟通 提供内部质量控制目的 向您提供信息 向您提供有关服务和产品的优惠和促销",
        "您或客户可能感兴趣的我们或其他方的产品增强您对网站、软件或移动应用程序的体验，包括保存您的偏好设置、登录信息等。分析网站、软件或移动应用程序的使用情况以及网站、软件或移动应用程序的使用情况运营我们的服务、产品、系统等。保护我们或其他人的利益、权利、财产或安全，并监控对与我们达成的任何协议条款的遵守情况和执行情况。提供客户支持和服务消息，包括请求您对我们的服务提供反馈的消息，并可能通知您有关我们的网站、服务的变更或我们的条款、条件和政策的变更。 随时进行安全审查，以验证您的身份、年龄、您提供的注册信息，并验证您对我们服务的使用和您的财务交易是否可能违反我们的总协议、条款和条件以及适用法律。安全审查可能包括订购信用报告和/或以其他方式根据第三方数据库验证您提供的信息。处理您的任何在线交易和付款（包括在必要时向第三方支付处理商和其他金融机构披露您的个人信息）。协助您参与第三方促销、市场研究和活动。 客户电话和聊天对话可能会被记录，以便我们提高客户服务和产品的质量、培训员工并记录后续投诉时的谈话内容。 在您表明或我们推断对我们的产品感兴趣的情况下，向您提供促销优惠和信息。 我们监控我们的网站、软件、移动应用程序、在线服务和产品的使用情况，并使用您的",
        "帮助我们改进和保护我们的在线和离线内容、服务和网站的个人信息。 我们使用个人信息为您个性化我们的网站、软件、移动应用程序、服务和产品。 我们监控客户帐户，以防止在我们的网站、软件、移动应用程序、服务和产品中使用不公平做法。我们使用个人信息来调查您或其他人收到的有关我们的网站、软件、移动应用程序、服务或产品的任何投诉。 我们可能需要与值得信赖的第三方共享您的数据，这些第三方为我们提供与我们的设施相关的服务，包括客户支持、信息安全、支付、营销、数据分析、研究和调查。 我们将在必要时将个人信息用于与法律索赔相关的目的以及合规、监管和调查目的（包括在法律程序或诉讼中披露此类信息）。 我们使用您的个人信息是为了建立您的人口统计资料、可能的行为和偏好的档案。这用于为我们做出与我们提供的服务、内容和促销相关的决策提供信息。我们还报告不同客户资料对我们商业绩效的不同贡献。我们通过手动或自动流程（包括来自第三方提供商的流程）创建个人资料。根据您的营销偏好（如果适用），我们将使用您的个人信息通过各种平台（例如电子邮件、短信、电话、邮寄、在线、收件箱消息、推送通知或其他可用渠道）传递您可能感兴趣的营销信息，以便向您提供有关我们的产品、服务和促销（包括其他）的信息。 与选定的媒体合作伙伴和附属机构分享您的联系方式，以便他们能够向您提供自己的营销服务。我们仅在征得您同意并符合您的营销偏好的情况下才会这样做。",
        "让您参与您同意的调查或促销活动。 我们根据我们的政策放置 cookie 并使用类似技术。 在我们征求您许可的其他情况下，我们会将您的个人信息用于我们当时解释的目的。 响应政府或执法机构进行调查的要求。 根据适用法律调查和/或报告欺诈、恐怖主义、失实陈述、安全事件或犯罪。我们使用从您那里获得的任何信用卡或支付信息来提供服务、产品或其他服务。您可以更新您的设置。请注意，以特定方式更改您的设置后，您将继续收到有关您的帐户、您请求的服务和产品的一些信息，并响应您的任何信息请求。请注意，您的设置的某些特定更改可能会对功能产生影响，并且您可能无法使用所有功能。请注意，如果使用选择退出功能，根据适用法律，可能需要一些时间才能完成。出于安全或其他商业目的以及纳入人员目录的目的，我们可能会拍摄视频或照片。数据备份责任我们会在技术和经济上合理的努力范围内，有效保护所有数据、信息和类似项目，防止未经授权的访问、修改、破坏或丢失、未经授权的传输、其他未经授权的处理和其他滥用。如果对数据、信息或类似项目的威胁无法通过技术上和经济上的适当努力以其他方式补救或补救效果不佳，LPT 有权删除包含破坏性内容的数据、信息或类似项目。",
        "合同终止的后果如果合同关系终止，无论法律原因如何，双方都有义务妥善履行合同关系。在这种情况下，LPT 有权立即删除客户的所有数据、信息或类似项目。合同终止时，客户的访问权限、帐户和类似项目将被自动阻止、屏蔽、删除或类似操作。 LPT 没有义务向客户移交数据、信息或任何类似内容。Cookie 和其他电子工具的使用我们以及与我们合作的各方（如服务提供商、广告商、广告服务器、业务合作伙伴等）可能会放置、使用、查看“cookie”、网络信标、网络服务器日志或其他电子工具，以收集有关您以及您对网站、其他网站、软件或移动应用程序的使用情况的统计信息和其他信息。这些信息可能包括您的 IP 地址、计算机的 IP 地址、浏览器类型、操作系统、您的移动设备、设置、浏览器类型、设备 ID、地理位置数据、您访问或注册本网站、软件或移动应用程序的州、城市、村庄或国家、您访问的网页、数据、访问时间、您在访问本网站之前和之后访问的网站、您在这些网站、软件或移动应用程序中点击的链接数量、您在这些网站上使用的功能您在这些网站、软件或移动应用程序上查看、请求的搜索、您在这些网站、软件或移动应用程序上保存或下载的数据和信息以及您查看广告（在网站、软件或移动应用程序等上）的次数等。我们以及我们可能出于各种原因使用所收集的信息和数据的各方，无论是代表我们还是其他方自己的目的，包括例如改进、研究、分析等，以更好地服务这些网站的用户、访问者或客户网站、软件或移动应用程序（例如通过注册、启用登录、提供对网站、软件或移动应用程序的页面、服务、产品的访问，提供定制或其他内容，在网站、软件或移动应用程序上呈现在线或离线广告），以编译有关这些网站、软件或移动应用程序的使用等的汇总和匿名信息和数据、其他统计数据等。如果您决定并已删除和禁用 cookie，则使用",
        "如果您想协助我们使用本隐私政策中所述的用途等，则收集、分析等有关您以及您对这些网站、软件或移动应用程序的使用的信息和数据可能会与来自其他在线或离线来源的有关您以及您的使用的个人或任何其他信息和数据进行汇总、分析或组合。如果您不希望我们将通过 cookie 收集的有关您和您对这些网站、软件或移动应用程序等的非个人信息和数据与有关您和您的使用等的个人或其他信息或数据相结合，请删除并禁用您用于上网冲浪的每台计算机、移动设备、笔记本电脑或任何其他设备上的每个浏览器的 cookie。请注意，大多数浏览器默认设置为接受 cookie。如果您愿意，通常可以将浏览器设置为在发送 Cookie 时提醒您或禁用 Cookie。根据移动设备，大多数允许您禁用从您的移动设备收集地理位置信息和数据的功能。大多数浏览器、移动设备或其他设备都有帮助或支持功能，其中包含有关如何设置您的浏览器、移动设备或其他设备以在接受之前通知您、禁用 cookie 或禁用地理位置数据和信息的收集的说明。您必须在用于上网的每台设备上设置您的偏好设置。但是，如果您禁用 Cookie 或拒绝接受放置 Cookie 或 Cookie 的请求，则网站、软件、移动应用程序或其他内容（例如民意调查、内容、调查、产品销售、可能更新或其他内容）的相同功能或部分以及网站、移动设备或其他您需要登录的其他内容以及网站、移动设备或其他内容的某些区域可能无法正常运行，并且您在访问网站、移动设备或其他内容时可能收到的广告或其他内容可能根本不适合您的兴趣或工作。",
        "广告我们、我们指定的服务提供商或第三方广告商或任何广告服务器可能会在您或我们的计算机、笔记本电脑、移动设备、软件、移动应用程序或其他电子工具或其他工具上放置或识别 cookie。但是，这些内容支持或帮助显示您可以在我们的网站、移动设备、软件、移动应用程序或任何其他应用程序上看到的广告。有关您访问或访问我们的网站、移动设备、软件、移动应用程序或其他设备以及在我们的网站、移动设备、软件、移动应用程序或其他设备上进行的活动的数据和信息、IP 地址、您查看广告的次数以及其他此类数据和信息，可单独使用或与其他数据和信息以任何形式组合使用，以在您的显示器、屏幕、移动设备或您可能特别感兴趣的任何其他设备上显示广告。我们或其他第三方可能会使用第三方广告公司或任何其他类型的公司提供的网络信标来帮助管理和优化我们的在线和离线广告和产品性能或类似内容。网络信标使我们能够在浏览器访问我们的网站或移动设备、软件、移动应用程序或其他网站时识别浏览器的 cookie，并使我们有机会了解哪些横幅广告或其他广告将用户带到我们的网站、移动设备、软件、移动应用程序或其他网站。本隐私政策不涵盖这些第三方服务提供商、第三方广告商及其广告服务器对您的数据和信息的使用和收集。如果您不接受其中任何一项，请不要访问和/或使用我们的网站、移动设备、移动应用程序、软件、设施、应用程序或其他。即使您选择有针对性的广告，您仍然可能会收到在线或离线广告。",
        "披露您的个人信息和数据我们可能会与其他附属公司（包括共同拥有或控制的附属网站）、子公司和指定服务提供商共享您的个人信息和数据，包括出于我们的隐私政策或我们的任何其他规定中规定的目的。我们可能会与其他第三方共享有关我们的网站用户、移动设备用户、软件、移动应用程序用户或我们的其他产品用户的数据和信息，例如您对我们的网站或其他网站、软件、移动应用程序以及我们的网站、移动设备、软件、移动应用程序或其他我们提供的服务的使用情况。我们可能会与赞助商、第三方提供商或其他第三方共享数据和信息（包括个人信息），从而为您提供促销、优惠或您可能感兴趣的其他信息和数据。如果您指示我们不要与此类第三方提供商共享我们的隐私政策所涵盖的您的个人信息，请使用选择退出功能。请注意，如果您决定使用此退出功能，请注意，我们的网站、软件、移动应用程序或其他功能的某些功能可能无法运行。此外请注意，此选择退出过程可能需要一些时间才能完成。即使在此类选择退出过程完成后，您的个人数据和个人信息可能会继续与我们的关联公司、子公司（包括共同拥有或控制的关联网站、共同拥有或控制的软件或共同拥有或控制的移动应用程序或类似其他人）和指定服务提供商共享。如果您决定参与我们网站、移动应用程序或其他的某些功能，请注意，您或其他人通过使用这些功能自愿披露的任何数据和信息（不包括安全数据和信息，如密码）将提供给我们和公众和/或您指定或未指定的其他用户。如果您选择向指定用户或个人提供访问权限，请注意，您发布的此类信息将可供此类用户或个人使用，我们也可能会看到。我们对您或其他人选择公开披露或向我们的网站、软件、移动应用程序或我们其他人上的指定个人提供访问权限的任何数据或信息不承担任何责任，并且我们或其他人使用此类数据和信息均不受本隐私政策的约束。如果我们真诚地认为此类披露是必要的或必要的，我们可能会将您的个人数据和信息披露给非关联第三方：保护我们的利益、权利、安全或财产，或",
        "其他；遵守任何适用的法律、法规、规则或响应法院命令或其他法律程序，但须遵守我们的规定；与执法部门和公共机构共享，以便遵守任何法律义务或我们认为我们有义务遵守某项义务。与第三方共享，以便执行我们的使用条款和任何其他协议；或保护我们、第三方或公众的权利、财产、安全或保障；如果您被发现欺骗或试图欺骗我们或我们服务的任何其他用户，其中可能包括但不限于操纵、支付欺诈或禁止交易，则与其他在线网站、银行、信用卡公司和应用程序适当机构分享； 在出售、购买资产、合并、破产或重组程序时与第三方共享；与第三方服务提供商共享，第三方服务提供商将代表我们出于上述目的进行处理。此类第三方包括网站托管、维护、呼叫中心运营、身份检查、信息验证服务、营销、数据分析、研究和调查的提供商、处理金融交易的第三方电子支付处理商和/或金融机构以及提供技术支持、处理您的在线交易和维护您的帐户的其他组织；监控对我们网站、软件、移动应用程序或其他服务的任何条款和或条件的遵守情况并执行；提供我们的服务、产品、软件、应用程序和其他（包括允许我们的购买者）或部门或子公司或其他人继续为您服务） 提供并执行与此类服务、产品、软件、应用程序和其他相关的其他活动（包括例如计费和收款） 向您提供我们或其他第三方的促销或优惠 正确操作提供和运行我们的服务、产品、软件、应用程序和其他内容的系统。",
        "第三方提供商或其他第三方收集、进一步使用和/或披露您的个人数据和信息和信息不是我们的责任。相反，此类收集、使用和/或披露受第三方隐私政策的约束。您个人信息的准确性、安全性和保留我们了解信息安全的重要性以及保护信息所需的技术。您提供给我们的任何数据和信息均保存在安全的地方。我们可能会使用第三方存储、云、服务器或其他。我们可能会使用合理的组织、技术和管理措施来保护您的个人数据免遭未经授权的访问或未经授权的更改、披露或销毁我们持有的信息。为了帮助我们保护您的隐私，您应该对您在参与我们的网站、服务、产品、软件、移动应用程序或我们的其他应用程序时设置的登录 ID 和密码保密。我们保留有关您的数据的期限将取决于收集数据的目的、您是否要求删除数据以及是否有任何法律义务要求保留数据（例如，出于监管合规性）。个人信息将在其收集目的所需的时间内保留，包括合法的商业原因和/或要求。保护和保护您的帐户信息这些是考虑如何确保登录信息安全的一些机会：切勿共享计算机帐户，切勿对多个帐户使用相同的密码，切勿告诉任何人您的密码，即使是自称来自客户服务或安全人员的人，切勿写下您的密码，切勿通过电话、电子邮件或即时消息传递密码。在离开计算机无人看管之前请小心注销只要怀疑密码可能已被泄露，请更改密码保持操作系统密码、软件和应用程序密码不同密码应为字母数字密码随机但易于记住维护最新的防病毒软件",
        "维护最新的个人防火墙避免在公众可以访问的计算机上使用您的帐户，例如。网吧定期更改您的密码保持您的操作系统、浏览器和浏览器插件处于最新状态禁用或卸载您不使用的任何软件或浏览器插件 — 这会减少您的漏洞。请明智地选择您的密码，例如添加大写和小写字母、一个或多个数字等。您可能会收到一条通知，例如您的密码应该过期或更改。您的个人信息的权利取决于管辖权：您可能有权访问、更正、删除或限制使用我们的隐私政策所涵盖的某些个人数据和信息；您可能有权要求我们避免处理个人信息。请注意，如果您行使此类权利，这可能会影响我们提供产品、服务的能力，我们的功能可能无法在网站、软件、移动应用程序或其他设备上运行。有关您的个人信息的疑问，请与我们联系。如果我们为了遵守我们的法律义务而处理您的个人信息，我们将按照适用法律规定的所有保留期限进行处理。虽然我们将尽合理努力满足此类请求，但我们保留在允许或要求的情况下对此类请求施加某些限制和要求的权利。请注意，此类请求可能需要一些时间。",
        "全球传输（将您的个人信息传输到其他国家）与任何跨国组织一样，我们经常需要在国际上传输数据。因此，有关您的数据可能会在全球范围内传输（如果您的数据是在欧洲经济区内收集的，这意味着您的数据可能会传输到欧洲经济区之外）。我们可能会将我们的隐私政策中提到的您的个人数据和信息传输到隐私保护级别可能与您所在国家不同的各个国家并在这些国家中进行处理。此外，我们的隐私政策中提到的一些使用和/或披露可能涉及将您的个人数据和信息传输到不同的国家并在这些国家中进行处理，这些国家的隐私保护级别可能与您所在的国家不同。通过进入我们的网站、移动设备或其他设备和/或使用我们的服务、产品、软件、移动应用程序或其他设备，您同意此类传输和处理，包括向美国或任何其他国家/地区传输和处理。此外，通过进入我们的网站、移动设备或其他设备和/或使用我们的服务、产品、软件、移动应用程序或其他设备，您同意您的个人数据和信息的隐私保护将与这些个人数据和信息传输到和正在处理的国家/地区相同。 电子商务根据实施的电子商务指令，公司提供以下与在互联网上签订合同（注册、付款和付款以及每项单独服务）有关的信息。 您在公司注册后，即表示您已达到相应国家法律制度规定的最低年龄。此外，您同意并接受涉及注册、付款和付款以及其他服务的全部协议、条款和条件。 您的合同公式（注册、进出、以及每项单独服务）均由公司或指定第三方保存。仅出于安全原因，您可以在您的个人帐户中查看和更改此数据的某些摘录。如果您想更改注册时提供的一些个人详细信息，您可以在您的帐户的“设置”下进行操作。在您的帐户中，您还可以通过单击“更改密码”来更改您的密码。",
        "第三方网站、软件、移动应用程序和其他网站的链接请注意，我们可能会提供第三方网站、软件、移动应用程序或其他网站（包括社交网站）的链接。由于我们不控制第三方网站、网站、软件、移动应用程序或其他网站，也不对您在此类网站、网站、软件、移动应用程序或其他网站上提供的任何数据或信息负责，因此我们鼓励您在此类网站、网站、软件、移动应用程序或其他网站上提供您的任何数据和信息之前阅读这些网站、网站、软件、移动应用程序或其他网站上的隐私政策。图像权我们可能会从各种来源获取照片、视频或其他内容。根据我们的隐私政策和提到的选择退出功能或其他，如果按照我们的隐私政策所述选择退出，请联系以下地址（“联系方式”下）。请注意，此类请求可能需要一些时间。WHO TO CONTACTLPT 在中国注册，公司编号为 91440400MACD90ME4A。如果您有任何疑问，或希望行使任何权利，请通过 Customer Service 联系我们。隐私政策的修改我们保留随时通过在我们的网站和/或平台和/或平台上发布修订内容来更改我们的隐私政策的权利。我们的软件和/或移动应用程序或其他应用程序。此类更改将在发布或上传后生效。我们建议您定期重新访问本隐私政策。无效或不可执行如果本协议的任何条款变得或被认定为无效或不可执行：本协议的所有其他条款仍具有完全效力；无效条款或不可执行条款应被视为自动修改并被有效或可执行条款取代，该条款在经济上尽可能实现无效和不可执行条款的目的和意图。",
        "同样的规则适用于意外遗漏（如果有）。 用户政策我们欢迎您访问我们的网站、设施、平台、软件、应用程序和其他。 LPT（以下简称“LPT”、“幸运丹鸟（珠海）科技有限公司”）及其附属公司（统称“我们”、“我们的”或“我们的”）。本用户政策适用于本网站、我们的任何软件或应用程序、我们的任何网站或我们的第三方网站、软件和应用程序（在线或离线），但不适用于我们的任何其他产品或服务，除非我们另有明确说明（例如在其他网站、我们的软件或我们的移动应用程序上包含指向本用户政策的链接）。 本网站、软件、移动应用程序和其他应用程序的使用我们的服务或产品仅允许出于个人、非商业和商业目的使用我们的网站、软件、移动应用程序或我们的其他服务和产品。严格禁止所有其他用途，如果您进入、访问、登录、注册我们的网站、软件、移动应用程序或我们的其他服务和产品，您同意：不会在任何其他网站、软件、移动应用程序（在线或离线）上收集、复制、提取和/或复制我们的网站、软件、移动应用程序、服务或产品的任何信息、数据或材料，无论使用任何类型的方法；不会使用我们的网站、软件、移动应用程序、服务或产品来向任何第三方提供与我们、我们的关联公司或我们的子公司有关的信息或数据，但与 LPT 的协议和合同中定义的您个人、非商业和商业目的除外；不得将我们的名称、品牌或我们网站的内容、软件、移动应用程序、服务或产品用于您个人、非商业和商业目的以外的任何其他目的；不得使用我们的故障、服务、产品、平台、网络",
        "网站、软件、应用程序或其他洗钱活动；受我们的用户政策的条款和条件、要求、条款和条件或我们的其他政策的法律约束。对我们的用户政策的修改我们保留通过在我们的网站和/或平台和/或软件和/或移动应用程序或我们的其他方面发布修订内容随时更改我们的用户政策的权利。此类更改将在发布或上传后生效。无效或不可执行如果本协议的任何条款变得或被认定为无效或不可执行：本协议的所有其他条款仍具有完全效力；无效条款或不可执行的条款应被视为自动修改并替换为有效或可执行的条款，该条款可在经济上尽可能经济地实现无效和不可执行条款的目的和意图。同样的规则适用于非故意的遗漏（如有）。社交媒体插件和其他的使用在我们的平台、设施、网站、软件、应用程序和我们的其他平台上，您可以找到链接和/或数据矩阵代码和/或任何与社交媒体服务的其他连接（“链接”），包括但不限于 Youtube、Myvideo、Facebook、Linkedin、Xing、Twitter、微信等。通过这些链接，您将进入他们的平台、设施、服务和其他内容，和/或让您有机会分享，包括但不限于页面、视频、图片和其他内容，这可能需要在社交媒体服务上拥有帐户。通过单击社交媒体服务的链接，可以建立与社交媒体服务的服务器或其他服务器的连接。这可能会将您访问我们的网站、平台、服务、设施、软件、应用程序或其他内容的信息和/或数据传输到服务器或社交媒体服务的其他内容。可能会将更多信息传输给社交媒体服务提供商。这些包括但不限于：激活的链接所在网站的地址访问网站或激活链接的日期和时间",
        "有关所使用的浏览器和操作系统的信息 IP 地址等。如果您在激活链接时已登录相关社交媒体服务，则社交媒体服务提供商可能能够确定您的用户名，如果适用，可能会从传输的数据中确定您的真实姓名，并将此信息与您在社交媒体服务上的个人用户帐户相关联。您可以通过事先注销您的用户帐户来排除此情况。社交媒体服务的服务器可能位于欧洲和/或可能位于美国和/或欧盟以外的其他国家。因此，欧盟以外国家的社交媒体服务提供商也可以处理这些数据。请注意，这些国家/地区的公司受到数据保护规定的约束，该规定通常不会像欧盟成员国那样保护个人数据。欲了解更多信息，请参阅相应社交媒体服务的隐私政策。在法律允许的范围内，我们不会对任何此类行为承担责任。 对我们的社交媒体插件和其他插件的修改我们保留随时通过在我们的网站和/或平台和/或软件和/或移动应用程序或我们的其他应用程序上发布修订版本来更改我们的社交媒体插件和其他插件的权利。此类更改将在发布或上传后生效。无效或不可执行如果本协议的任何条款变得或被认定为无效或不可执行：本协议的所有其他条款仍具有完全效力；无效条款或不可执行条款应被视为自动修改并被有效或可执行条款取代，该条款在经济上尽可能实现无效和不可执行条款的目的和意图。同样的规则适用于非故意遗漏（如果有）。"
      ],
      privacyContent: "这是LPT审核平台的隐私政策...",
      close: "关闭"
    },
    payment: {
      innerSteps: {
        "0": "选择方法",
        "1": "支付",
        "2": "确认"
      },
      modes: {
        oneTime: {
          title: "一次性付款",
          badge: "一次付清",
          desc: "一次性完成支付。"
        },
        subscription: {
          title: "订阅制",
          badge: "自动续费",
          desc: "按周期自动扣费并续订。"
        }
      },
      selectMethod: "选择您的付款方式",
      oneTime: {
        desc: "请选择一次性付款方式。"
      },
      amountToPay: "支付金额",
      recommended: "受到推崇的",
      proceedToPay: "继续付款",
      methodMeta: {
        processor: "处理方",
        flow: "流程"
      },
      alipayProceed: "前往支付宝付款",
      alipayRedirectTip: "即将跳转至安全支付页面（Alipay）。",
      alipayMode: {
        title: "选择支付宝支付方式",
        subtitle: "可跳转登录支付，也可扫码支付。",
        redirect: {
          title: "跳转登录支付",
          desc: "前往支付宝官方收银台登录并完成付款。",
          tip: "即将跳转至支付宝官方收银台，请在新页面完成登录付款。",
          action: "跳转至支付宝"
        },
        qr: {
          title: "二维码支付",
          desc: "使用支付宝 App 扫码完成付款。",
          tip: "打开支付宝 App，扫描二维码完成支付。",
          generating: "正在生成支付宝二维码，请稍候...",
          orderNo: "订单号",
          checkStatus: "我已完成支付",
          pending: "暂未检测到支付成功，请稍后再试。"
        }
      },
      scanQrCode: "打开支付宝，扫描二维码即可支付",
      qrExpires: "二维码将在 {seconds} 秒后过期",
      qrExpired: "二维码已过期。请再试一次。",
      simulatePay: "模拟支付成功",
      verifying: "正在验证付款...",
      changeMethod: "变更方法",
      processing: "正在处理付款...",
      payNow: "立即付款 {amount}",
      initError: "无法初始化支付，请重试。",
      formLoadError: "支付表单未加载，请重试。",
      cardFailed: "支付失败，请检查卡号信息。",
      fillAllFields: "请填写所有卡的详细信息",
      securityNote: "您的付款信息已加密。我们不会存储您的银行卡详细信息。",
      subscription: {
        title: "订阅结账",
        desc: "你的套餐会按所选周期自动续费。",
        amountLabel: "续费金额",
        start: "开始订阅",
        checkoutMethod: "Stripe Checkout",
        cardTitle: "订阅信息",
        interval: "计费周期",
        monthly: "按月",
        yearly: "按年",
        renewal: "续费方式",
        autoRenew: "已开启自动续费",
        paymentMethod: "付款方式",
        cardOnly: "通过 Stripe Checkout 使用银行卡",
        checkoutError: "无法启动订阅，请重试。"
      },
      wechat: {
        scanQrCode: "打开微信扫码支付",
        generating: "正在生成二维码，请稍候..."
      },
      methods: {
        card: {
          name: "银行卡支付",
          shortName: "CARD",
          desc: "可使用 Visa、Mastercard 或其他支持的银行卡安全支付。",
          badge: "Visa / Mastercard",
          processor: "安全支付网关",
          flow: "内嵌安全表单"
        },
        stripe: {
          name: "Stripe"
        },
        alipay: {
          name: "支付宝直连",
          desc: "通过支付宝直连通道付款，并跳转至支付宝官方收银台完成支付。",
          badge: "直连通道",
          processor: "支付宝",
          flow: "跳转支付宝"
        },
        visa: {
          name: "签证",
          desc: "使用 Visa 信用卡或借记卡付款"
        },
        mastercard: {
          name: "万事达",
          desc: "使用万事达信用卡或借记卡付款"
        },
        wechat: {
          name: "微信支付",
          desc: "微信扫码支付"
        }
      },
      cardForm: {
        kicker: "安全结账",
        title: "银行卡支付",
        acceptedCards: "支持的卡种",
        moreCards: "银行卡",
        cardDetails: "银行卡信息",
        helper: "请在安全加密表单中输入银行卡信息。",
        number: "卡号",
        numberPlaceholder: "0000 0000 0000 0000",
        holderName: "持卡人姓名",
        holderNamePlaceholder: "卡上的姓名",
        expiry: "到期日",
        expiryPlaceholder: "月/年",
        cvv: "安全码",
        cvvPlaceholder: "•••"
      },
      result: {
        oneTimeSuccessTitle: "付款成功！",
        oneTimeSuccessDesc: "一次性付款已完成，欢迎来到 LPT 平台！",
        subscriptionSuccessTitle: "订阅已激活！",
        subscriptionSuccessDesc: "您的订阅已生效，并会自动续费。",
        failedTitle: "付款失败",
        failedDesc: "处理您的付款时出现问题。请重试或使用其他方法。",
        orderId: "订单号",
        amount: "支付金额",
        method: "付款方式",
        time: "付款时间",
        downloadShortcut: "下载LPT审核平台",
        shortcutFileName: "LPT审计平台",
        viewInvoice: "查看发票",
        shortcutDownloaded: "LPT审计平台快捷方式已下载",
        goToDashboard: "转到仪表板",
        retry: "再试一次"
      }
    },
    invoice: {
      paymentQr: {
        title: '付款二维码信息',
        alt: 'MT 发票付款二维码'
      },
      exportPdf: "导出PDF",
      tax: "税",
      taxWithRate: "税（{rate}）",
      seeInvoice: "见发票",
      labels: {
        documentTitle: "发票/借项通知单", issueDate: "开具日期", clientNo: "客户编号", organization: "组织", address: "地址", name: "姓名", email: "电子邮箱", phone: "电话", taxId: "税号", registrationNo: "注册号", matter: "事项", period: "期间", currency: "币种", amount: "金额", subtotal: "小计", discount: "折扣", billingAmount: "账单金额", customerService: "客户服务", customerServiceText: "您可以随时通过账户中的客户服务联系我们。", paymentInstructions: "付款说明", paymentText: "您的银行账户将在未来几天内扣除账单金额。请注意，扣款金额不包含任何电汇或其他银行手续费。相关条款和条件适用。", paymentNote: "您可以在一段时间内从软件的付款历史记录中查看发票。", bankInformation: "我们的银行信息"
      },
      exportingPdf: "导出中...",
      exportXml: "导出XML",
      exportingXml: "XML导出中...",
      uploadedTitle: "已上传发票",
      openUploadedInvoice: "打开发票",
      downloadUploadedImage: "下载发票图片",
      downloadUploadedImageFailed: "发票图片下载失败。",
      languagesLine: "语言：{languages}",
      xmlExportSuccess: "XML发票已导出。",
      xmlExportFailed: "XML发票导出失败。",
      xmlExportMissingFields: "无法导出XML，缺少必填字段：{fields}。",
      xmlFields: {
        invoiceNumber: "发票编号",
        issueDate: "开票日期",
        currency: "币种",
        supplierName: "供应商名称",
        customerOrganization: "客户组织",
        customerAddress: "客户地址",
        invoiceItems: "发票明细",
        totalAmount: "总金额"
      }
    },
    errors: {
      loadPurchaseConfig: "无法加载购买配置，请稍后重试。",
      createOrder: "订单创建失败，请检查登录状态。"
    }
  },
  login: {
    backButtonTitle: "返回",
    title: "登 录",
    subtitle: "请输入您的凭据以访问您的帐户",
    emailLabel: "电子邮箱",
    emailPlaceholder: "请输入邮箱地址",
    passwordLabel: "密码",
    passwordPlaceholder: "请输入密码",
    rememberMe: "记住我",
    forgotPassword: "忘记密码？",
    loginButton: "立即登录",
    registerPrompt: "还没有账号？",
    registerLink: "创建账号",
    loginSuccess: "登录成功",
    loginFailed: "登录失败",
    incorrectCredentials: "邮箱或密码错误",
    userNotFound: "用户未找到",
    formInvalid: "请正确填写表单",
    validation: {
      emailRequired: "要求输入邮箱地址",
      emailInvalid: "请输入正确的邮箱地址",
      passwordRequired: "请输入密码"
    },
    viewTerms: "服务条款",
    viewPrivacy: "隐私政策",
    agreePrefix: "我已阅读并同意",
    agreeAnd: "和",
    termsOfService: "服务条款",
    privacyPolicy: "隐私政策",
    close: "关闭",
    termsClose: "关闭",
    privacyContent: "隐私政策内容。",
    termsContent: [
      "幸运丹鸟（珠海）科技有限公司协议、条款和条件",
      "这些协议、条款和条件，包括但不限于数据处理和安全协议或条款、各项协议附录、服务水平协议以及不时修订的 LPT Audit 可接受使用政策，在您（被许可方）与中华人民共和国企业幸运丹鸟（珠海）科技有限公司（以下简称“LPT”或“我们”）之间构成关于您使用许可材料的法律合同。访问许可材料前，您必须先查看并同意这些条款。禁止以违反协议条款和/或政策的方式使用许可材料。任何被指定为被许可方、客户、审核员或审核客户的个人或实体，均应在适用范围内受本协议约束。本协议也适用于我们不时向您提供的任何其他材料、服务或功能。\n\n点击同意和/或使用许可材料，即表示您确认同意本协议条款。\n如不同意，请勿使用许可材料，并立即退出 LPT Audit 平台。",
      "定义\n\n“协议”是指本协议及其条款，包括所有条款和条件、附录、服务水平协议、数据处理协议、纳入本协议的各项政策，以及不时修订的所有附件、附表和证明文件。\n“可接受使用政策”是指 LPT 网站上提供并通过引用纳入本协议的政策。\n“关联方”是指控制一方、受一方控制或与一方受共同控制的任何实体。\n“授权用户”是指经被许可方授权并依据本协议访问许可材料的员工或独立承包商。\n“内容”是指许可材料中或通过许可材料提供的所有内容，包括文本、数据、图示、表演、图像、商标、商号和标识。\n“客户”是指委托 LPT Audit 或审核员开展审核的个人或实体。\n“附录”是指规定某项审核标准和/或模板许可材料使用条款的协议，LPT Audit 可不时对其更新、修订或补充。\n“审核员”是指代表客户开展审核的个人或实体。\n“审核客户”是指委托审核员开展审核的个人或实体。\n“审核标准”是指相关附录中规定并纳入许可材料的审核标准。\n“授权目的”仅指开展审核或相关活动。\n“授权人员”是指获准访问许可材料的人员。\n“数据处理和安全协议”或“DPA”是指 LPT 网站上提供的个人数据处理协议。\n“被许可方”是指获准使用许可材料的个人或实体。\n“许可材料”包括提供给被许可方的审核软件、报告模板、附录和/或其他材料。\n“政策”是指 LPT 网站上提供的政策。\n“报告模板”或“模板”是指报告模板。\n“服务水平协议”或“SLA”是指关于以服务形式提供许可材料可用性的协议。\n“用户指南”是指 LPT 网站上提供的许可材料使用说明。\n“版本”是指许可材料的任何版本号。",
      "条件和限制\n\n许可材料的使用受本协议约束。\n如果我们自行认定被许可方违反本协议，可随时暂停或终止许可。\n被许可方必须确保每位审核客户在使用许可材料前同意 LPT Audit 客户使用条款。",
      "隐私政策\n\nLPT 根据隐私政策收集和处理个人数据。\n所有数据均依照适用的数据保护法规进行处理。",
      "许可授予\n\n在遵守本协议条款和条件的前提下，LPT 授予被许可方一项非独占、不可转让、全球范围且可撤销的许可，仅限在许可期限内为授权目的使用许可材料。\n本协议不授予任何其他权利。",
      "所有权和知识产权\n\n许可材料归 LPT 或其许可方所有。\n许可材料中的所有知识产权均由 LPT 及其许可方专有。",
      "费用和付款\n\n许可材料的使用费用以适用附录或价格表为准。\n除非另有说明，所有费用均不予退还。"
    ]
  },
  resetPassword: {
    backButtonTitle: "返回",
    title: "重置密码",
    subtitle: "请输入邮箱、验证码和新密码",
    emailLabel: "电子邮箱",
    emailPlaceholder: "请输入邮箱地址",
    verificationCodeLabel: "验证码",
    verificationCodePlaceholder: "请输入验证码",
    newPasswordLabel: "新密码",
    newPasswordPlaceholder: "请输入新密码",
    confirmPasswordLabel: "确认密码",
    confirmPasswordPlaceholder: "请再次输入新密码",
    sendCodeButton: "获取验证码",
    codeCountdown: "{seconds}秒",
    submitButton: "重置密码",
    loginPrompt: "想起密码了？",
    loginLink: "返回登录",
    codeSent: "验证码已发送",
    codeSendFailed: "验证码发送失败",
    resetSuccess: "密码重置成功",
    resetFailed: "密码重置失败",
    formInvalid: "请正确填写表单",
    validation: {
      emailRequired: "请输入邮箱地址",
      emailInvalid: "请输入正确的邮箱地址",
      codeRequired: "请输入验证码",
      passwordRequired: "请输入新密码",
      passwordMin: "密码长度至少为8位",
      confirmPasswordRequired: "请确认新密码",
      passwordMismatch: "两次输入的密码不一致"
    }
  },
  register: {
    title: '创建账号',
    subtitle: '填写以下信息以开始',
    backButtonTitle: '返回',
    orgInfoSection: '组织信息',
    addressSection: '地址与联系方式',
    adminSection: '管理员信息',
    nameLabel: '组织名称',
    namePlaceholder: '请输入组织名称',
    legalNameLabel: '法定名称',
    legalNamePlaceholder: '请输入法定名称',
    industryLabel: '行业',
    industryPlaceholder: '选择行业（可多选）',
    regTypeLabel: '注册类型',
    regTypePlaceholder: '选择类型',
    regNumLabel: '注册号',
    regNumPlaceholder: '请输入注册号',
    regNumTooltip: '由当地主管机构颁发的官方注册号',
    taxIdLabel: '税号',
    taxIdPlaceholder: '请输入税号',
    legalRepLastNameLabel: '法定代表人姓',
    legalRepLastNamePlaceholder: '请输入姓',
    legalRepFirstNameLabel: '法定代表人名',
    legalRepFirstNamePlaceholder: '请输入名',
    addressLine1Label: '地址行1',
    addressLine1Placeholder: '请输入街道地址',
    addressLine2Label: '地址行2',
    addressLine2Placeholder: '请输入公寓、套房等（选填）',
    countryLabel: '国家/地区',
    countryPlaceholder: '选择国家/地区',
    stateLabel: '州/省',
    statePlaceholder: '请输入州/省',
    cityLabel: '城市',
    cityPlaceholder: '请输入城市',
    postalCodeLabel: '邮政编码',
    postalCodePlaceholder: '请输入邮政编码',
    contactEmailLabel: '联系邮箱',
    contactEmailPlaceholder: '请输入联系邮箱',
    phoneLabel: '电话号码',
    phonePlaceholder: '请输入电话号码',
    lastNameLabel: '姓',
    lastNamePlaceholder: '请输入姓',
    firstNameLabel: '名',
    firstNamePlaceholder: '请输入名',
    adminEmailLabel: '管理员邮箱',
    adminEmailPlaceholder: '请输入管理员邮箱',
    verificationCodeLabel: '邮箱验证码',
    verificationCodePlaceholder: '请输入6位数字验证码',
    sendCodeButton: '获取验证码',
    codeCountdown: '{seconds}秒',
    codeSent: '验证码已发送至管理员邮箱',
    codeSendFailed: '验证码发送失败',
    adminPhoneLabel: '管理员电话',
    adminPhonePlaceholder: '请输入管理员电话',
    passwordLabel: '密码',
    passwordPlaceholder: '请输入密码',
    confirmPasswordLabel: '确认密码',
    confirmPasswordPlaceholder: '请确认密码',
    adminAddressLine1Label: '管理员地址行1',
    adminAddressLine1Placeholder: '请输入管理员街道地址',
    adminAddressLine2Label: '管理员地址行2',
    adminAddressLine2Placeholder: '请输入管理员公寓、套房等（选填）',
    adminCountryLabel: '管理员国家/地区',
    adminCountryPlaceholder: '选择国家/地区',
    adminStateLabel: '管理员州/省',
    adminStatePlaceholder: '请输入管理员州/省',
    adminCityLabel: '管理员城市',
    adminCityPlaceholder: '请输入管理员城市',
    adminPostalCodeLabel: '管理员邮政编码',
    adminPostalCodePlaceholder: '请输入管理员邮政编码',
    agreementCheckbox: '我已阅读并同意 ',
    agreementLink: '服务条款',
    submitButton: '提交',
    resetButton: '重置',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    viewTerms: '服务条款',
    viewPrivacy: '隐私政策',
    termsClose: '关闭',
    termsCloseButton: '关闭',
    termsAgreeButton: '同意',
    termsContent: [
      '幸运丹鸟（珠海）科技有限公司协议、条款和条件',
      '这些协议、条款和条件，包括但不限于数据处理和安全协议或条款、每个协议附录、服务水平协议以及LPT审计可接受使用政策，在您（被许可方）与幸运丹鸟（珠海）科技有限公司（LPT、我们）之间构成具有法律约束力的合同，供您使用许可材料。',
      '协议、条款和条件\n\n使用许可材料须遵守协议。\n如果我们自行认定您违反了本协议，我们可能会随时暂停或终止许可。\n在许可材料被审计客户使用之前，被许可方必须确保每个审计客户同意LPT审计客户使用条款。',
      '隐私政策\n\nLPT根据隐私政策收集和处理个人数据。\n所有数据的处理均遵守适用的数据保护法规。',
    ],
    privacyContent: '这是LPT审核平台的隐私政策。所有个人数据的处理均遵守适用的数据保护法规。如需更多详细信息，请联系我们的支持团队。',
    accountCreateSuccess: '账号创建成功',
    accountCreateFail: '账号创建失败',
    formError: '请正确填写所有必填字段',
    validation: {
      confirmPasswordMismatch: '两次输入的密码不一致',
      passwordRequired: '请输入密码',
      passwordInvalid: '密码至少8位，需包含大写字母、小写字母和数字',
      orgNameRequired: '请输入组织名称',
      legalNameRequired: '请输入法定名称',
      contactEmailRequired: '请输入联系邮箱',
      emailInvalid: '请输入有效的邮箱地址',
      phoneRequired: '请输入电话号码',
      regTypeRequired: '请选择注册类型',
      regNumRequired: '请输入注册号',
      taxIdRequired: '请输入税号',
      legalRepLastNameRequired: '请输入法定代表人姓',
      legalRepFirstNameRequired: '请输入法定代表人名',
      addressRequired: '请输入地址',
      stateRequired: '请输入州/省',
      cityRequired: '请输入城市',
      postalCodeRequired: '请输入邮政编码',
      countryRequired: '请选择国家/地区',
      adminEmailRequired: '请输入管理员邮箱',
      verificationCodeRequired: '请输入邮箱验证码',
      verificationCodeInvalid: '验证码必须为6位数字',
      firstNameRequired: '请输入名',
      lastNameRequired: '请输入姓',
      agreementRequired: '请先同意服务条款'
    },
    industryOptions: {
      platforms: '平台',
      advertising: '广告',
      energy: '能源',
      data_and_analytics: '数据与分析',
      messaging_and_telecommunications: '消息与电信',
      lending_and_investments: '贷款与投资',
      real_estate: '房地产',
      consumer_electronics: '消费电子',
      administrative_services: '行政服务',
      health_care: '医疗保健',
      agriculture_and_farming: '农业',
      community_and_lifestyle: '社区与生活方式',
      social_impact: '社会影响力',
      events: '活动',
      clothing_and_apparel: '服装',
      video: '视频',
      internet_services: '互联网服务',
      travel_and_tourism: '旅游',
      information_technology: '信息技术',
      content_and_publishing: '内容与出版',
      mobile: '移动',
      government_and_military: '政府与军事',
      artificial_intelligence: '人工智能',
      blockchain_and_cryptocurrency: '区块链与加密货币',
      sustainability: '可持续发展',
      hardware: '硬件',
      sales_and_marketing: '销售与营销',
      transportation: '运输',
      payments: '支付',
      gaming: '游戏',
      science_and_engineering: '科学与工程',
      apps: '应用',
      biotechnology: '生物技术',
      professional_services: '专业服务',
      navigation_and_mapping: '导航与地图',
      design: '设计',
      sports: '体育',
      education: '教育',
      natural_resources: '自然资源',
      commerce_and_shopping: '商务与购物',
      manufacturing: '制造业',
      media_and_entertainment: '媒体与娱乐',
      software: '软件',
      consumer_goods: '消费品',
      other: '其他',
      music_and_audio: '音乐与音频',
      privacy_and_security: '隐私与安全',
      financial_services: '金融服务',
      food_and_beverage: '食品与饮料'
    },
    registrationTypeOptions: {
      china_business_license: '中国营业执照',
      germany_handelsregister: '德国商业登记摘录',
      other: '其他'
    },
    registrationTypesLoading: '加载中…',
    registrationTypesEmpty: '暂无可选的注册类型',
    registrationNumberExample: '示例'
  },
  faq: {
    hero: {
      badge: "帮助中心",
      title: "常见问题解答",
      subtitle: "关于 LPT 审计平台您需要了解的一切。在下面查找常见问题的答案。",
      searchPlaceholder: "搜索问题..."
    },
    quickTags: {
      pricing: "定价",
      security: "数据安全",
      iso: "国际标准化组织标准",
      trial: "免费试用"
    },
    categories: {
      all: "所有问题",
      general: "一般信息",
      pricing: "定价和计划",
      features: "特性和功能",
      security: "安全与合规性",
      account: "帐户和用户",
      technical: "技术支援"
    },
    searchResults: "找到“{query}”的 {count} 个结果",
    clearSearch: "清除搜索",
    helpful: "这有帮助吗？",
    yes: "是的",
    no: "不",
    thanksFeedback: "感谢您的反馈！",
    noResults: "没有找到匹配的问题",
    noResultsDesc: "请调整您的搜索关键字或浏览所有类别。",
    showAll: "显示所有问题",
    cta: {
      title: "还有疑问吗？",
      subtitle: "我们的审计专家随时准备为您的组织找到合适的解决方案。",
      contactSupport: "联系支持人员",
      bookDemo: "预订演示"
    },
    items: {
      whatIsLpt: {
        q: "什么是LPT软件平台？",
        a: "LPT软件平台是一个全面的、基于云的审计管理和管理系统解决方案，专为专业审计师和组织而设计。它支持多种国际标准，包括 ISO 9001、ISO 14001、ISO 27001、IATF 16949、VDA 6.3 等，提供从规划到报告的端到端审计工作流程管理。"
      },
      auditStandards: {
        q: "支持哪些审核标准？",
        a: "我们支持广泛的国际标准，包括 ISO 9001、IATF 16949、VDA 6.3、ISO 14001、ISO 45001、TISAX 和 ISO 27001。您还可以使用我们的模板创建工具创建自定义审核模板。"
      },
      getStarted: {
        q: "我如何开始使用我们的软件解决方案？",
        a: "入门很简单：1) 注册您的组织帐户，2) 选择订阅计划，3) 选择您的审核标准，4) 邀请您的审核员。您可以在几分钟内启动并运行。"
      },
      pricingPlans: {
        q: "有哪些定价计划可供选择？",
        a: "我们提供多种选择，也可以为您节省大量费用。请参阅我们的产品了解更多详情。"
      },
      cancelSubscription: {
        q: "我可以取消或更改我的订阅吗？",
        a: "是的，您可以从帐户设置中更改或取消订阅。"
      },
      paymentMethods: {
        q: "接受哪些付款方式？",
        a: "我们接受 Visa、Mastercard、微信和支付宝以及其他卡，具体取决于您所在的国家/地区。所有付款均通过我们安全、符合 PCI DSS 的支付网关进行处理。"
      },
      customTemplates: {
        q: "我可以创建自定义审核模板吗？",
        a: "是的，有两种方法可以创建您自己的审核模板。我们的软件解决方案之一包括功能强大的模板创建工具，用于构建定制的清单和评分标准。如果您有特定模板但在我们的产品组合中找不到它们，另一种方法是联系我们。"
      },
      supplierPortalWork: {
        q: "供应商门户如何运作？",
        a: "供应商门户为您的供应商提供无限制的免费访问权限，以响应审核、上传证据以及按照审核员的要求和定义管理行动管理。"
      },
      shareAuditsInternal: {
        q: "我可以在组织内分享我的审核吗？",
        a: "是的，审核员可以将内部用户添加到内部池中，并让他们免费访问软件平台。"
      },
      accessCost: {
        q: "供应商、内部用户、客户和其他人的访问是否需要付费？",
        a: "不，这些访问权限包含在我们所有的审计软件解决方案中。"
      },
      shareAuditsExternal: {
        q: "我可以与认证机构或客户分享我的审核结果吗？",
        a: "是的，您可以共享它们，并且免费访问下摆。您可以为他们创建一个帐户，他们可以访问您共享的审核。"
      },
      offlineMode: {
        q: "我可以离线使用我的审计软件吗？",
        a: "是的，我们的审计软件解决方案具有离线模式。"
      },
      exportAudits: {
        q: "我可以导出我的审核吗？",
        a: "您可以免费与所有人分享您的审核。他们将可以通过门户进行访问，并可以访问审核员共享的审核。"
      },
      removeAccess: {
        q: "共享后如何删除访问或审核？",
        a: "您可以作为审核员随时取消共享审核并删除访问权限。"
      },
      dataSecurity: {
        q: "我的数据如何受到保护？",
        a: "所有数据在静态 (AES-256) 和传输中 (TLS 1.3) 均经过加密。我们的管理体系和基础设施参考 ISO 27001 和 TISAX。"
      },
      backupHandling: {
        q: "备份是如何处理的？",
        a: "我们通过异地冗余执行自动定期备份。"
      },
      auditorLimit: {
        q: "审核员或审核人数是否有限制？",
        a: "不，审核员或审计没有限制。许可证对审核员具有约束力，但您始终可以将新许可证和审核员添加到审核员池中。"
      },
      supportedLanguages: {
        q: "支持哪些语言？",
        a: "我们的软件目前支持英语、中文、德语、西班牙语、法语。也可以用这些语言生成报告。"
      },
      auditManagementSupport: {
        q: "该审计软件如何支持我的审计管理？",
        a: "我们的审计软件提供广泛的支持。例如，审核报告是在审核员进行审核时自动创建的。审核员随后可以审查审核报告，并可以根据需要或希望进行调整。<br><br>审核工作流程已实施并支持审核员的活动。每个标准章节都已实施，并且如果审核员提出不确定性，则会自动切换。"
      },
      inexexperiencedUser: {
        q: "即使我的审计经验较少，我可以使用审计软件吗？",
        a: "是的，我们的审核软件是直观开发的，可以指导您完成审核。自动化基础设施由世界各地的第三方审核员创建，以确保工作流程的一致性。"
      },
      uploadFiles: {
        q: "我可以上传文件或图片进行审核吗？",
        a: "是的，您可以拍摄照片或文件并将其上传到您的审核中。"
      },
      multipleAuditors: {
        q: "我可以与多名审核员一起进行审核吗？",
        a: "是的，您可以与多名审核员一起进行审核。所有审核员可以同时在我们的软件中协同工作。审核员必须添加到审核员池中，因此您可以将他们作为首席审核员或联合审核员添加到审核中。"
      },
      buyLicences: {
        q: "谁可以购买许可证并创建审核员？",
        a: "许可证以及将审核员绑定到许可证只能在平台上由管理员完成。请注意，许可证对审核员具有约束力，不能切换给其他审核员。每个审核员都需要自己的执照。"
      },
      addTemplates: {
        q: "我可以稍后向我的帐户添加更多审核模板吗？",
        a: "是的，您可以随时向您的帐户添加新的审核模板。购买后即可使用模板。"
      },
      templatePurchase: {
        q: "我是否必须为每位审核员单独购买模板？",
        a: "不需要，一旦组织购买了审核模板，该组织绑定的所有持证审核员都可以使用该模板。"
      }
    }
  },
  more: "更多的",
  productionBrain: {
    downloadShortcut: {
      title: "下载网站快捷方式",
      desc: "一键接入LPT审计平台",
      btn: "立即下载"
    },
    hero: {
      badge: "互联平台",
      title: "将审计从清单提升为战略资产",
      desc1: "将您的风险、合规性和审计管理统一在一个强大的平台上。",
      desc2: "自动化审计管理，通过自动化和精益的工作流程提高审计团队的效率。",
      btnShop: "店铺",
      btnExplore: "探索平台之旅"
    },
    stats: {
      timeSaved: {
        value: ">30%",
        label: "节省时间",
        desc: "每年平均节省手动证据收集时间。"
      },
      riskVisibility: {
        value: "即时的",
        label: "风险可见性",
        desc: "从时间点检查过渡到持续保证。"
      },
      integrations: {
        value: "100+",
        label: "集成",
        desc: "无缝插入您现有的基础设施。"
      },
      surpriseFindings: {
        value: "零",
        label: "令人惊讶的发现",
        desc: "在外部审计员到达之前发现控制故障。"
      }
    },
    solutions: {
      header: {
        title: "专为各个业务领域而设计",
        desc: "无论您是在世界各地还是本地管理复杂、简单或灵活的审计或管理系统，我们的解决方案都能适应您的特定方法。"
      },
      items: [
        {
          title: "审计管理",
          description: "简化整个审计生命周期。为审计团队实现评估、工作流程管理和动态报告的自动化。"
        },
        {
          title: "IT 与安全合规性",
          description: "加快 ISO 27001、TISAX、PCI-DDS 和 HIPAA 合规性。控制映射可确保您跨多个框架进行测试、审查和合规。"
        },
        {
          title: "自动化工作流程",
          description: "数字化您的审计工作流程和管理。整个审计程序的自动化工作流程。"
        },
        {
          title: "数字化",
          description: "数字化您的审计管理和合规计划。跟踪 RCM（风险控制矩阵）、管理认证并自动化缺陷工作流程。"
        }
      ]
    },
    features: {
      header: {
        title: "企业级功能",
        desc: "一个综合工具包，旨在集中数据、自动化工作流程并提供可行的分析。"
      },
      items: [
        {
          title: "数据驱动的风险评估",
          description: "根据您的审计结果和审查进行前期和后期风险评估。",
          list: [
            "自定义风险评分",
            "热图生成",
            "动态风险登记册"
          ]
        },
        {
          title: "直接实施",
          description: "消除带有证据的单独文件夹。将文件、照片等直接纳入您的审核中。",
          list: [
            "上传照片进入审核",
            "上传文件进入审核",
            "上传到库"
          ]
        },
        {
          title: "问题和补救跟踪",
          description: "不要让调查结果被遗漏。分配问题、设定截止日期并跟踪补救计划直至结束。",
          list: [
            "自动化动作管理",
            "自动跟进",
            "综合供应商行动管理"
          ]
        },
        {
          title: "通过自动化实现一致性",
          description: "连接的功能确保整个审计程序中数据和信息的一致性。",
          list: [
            "自动同步",
            "审计程序之间的自动转移",
            "通过工作流程预防故障"
          ]
        },
        {
          title: "智能框架管理",
          description: "不同工具之间的自动链接和连接确保了有效性和效率。",
          list: [
            "人行横道测绘",
            "预构建框架",
            "差距分析"
          ]
        },
        {
          title: "高级活动目录",
          description: "将所有数据保存在审计驾驶舱中。邀请供应商和客户加入，但仍将密钥掌握在您手中。定义访问权限和角色。",
          list: [
            "受控邀请",
            "由审核员管理访问",
            "受控审计共享"
          ]
        }
      ]
    },
    integration: {
      title: "数字化您的整个审计管理",
      desc: "我们的软件解决方案提供了完整的审计管理系统。所有数据和信息都将以数字形式提供，并符合我们提供的标准。",
      benefits: {
        digitalization: {
          label: "全数字化：",
          text: "一款用于您的审计管理的软件。"
        },
        sync: {
          label: "连续同步：",
          text: "定期同步可确保您的合规状况始终保持最新。"
        },
        data: {
          label: "受控数据：",
          text: "您可以控制审核数据的共享和取消共享。"
        }
      },
      nodes: {
        center: "审计",
        offline: "离线模式",
        portal: "供应商门户",
        templates: "准备就绪的模板",
        workflows: "自动化工作流程",
        permissions: "权限管理",
        library: "数字图书馆"
      }
    },
    workflow: {
      header: {
        title: "智能审计生命周期",
        desc: "简化的流程旨在实现从规划到报告的最高效率和绝对准确性。"
      },
      items: [
        {
          title: "1. 计划与范围",
          description: "定义您的策略，与风险登记册保持一致，并根据审计员的可用性自动分配资源。"
        },
        {
          title: "2. 进行实地考察",
          description: "利用数字工作文件，在平台内实时协作，并无缝捕获自动化证据。"
        },
        {
          title: "3. 审查和修复",
          description: "立即突出显示差异。自动将调查结果发送给行动负责人以便快速修复。"
        },
        {
          title: "4. 报告与监控",
          description: "立即发布最终审计报告。转向持续监控，以确保控制措施全年有效。"
        }
      ]
    },
    value: {
      title: "银行级安全性和可靠性",
      lead: "您的审计数据是您最敏感的资产。我们通过旨在满足最严格的全球标准的企业级安全架构来保护它。",
      props: [
        {
          title: "数据驻留与合规性",
          desc: "将您的数据托管在区域 AWS/Azure 数据中心，以遵守当地数据保护法（GDPR、CCPA）。"
        },
        {
          title: "基于角色的访问控制 (RBAC)",
          desc: "精细的权限确保用户只能看到分配给他们的数据、控件和工作流程。"
        },
        {
          title: "不可变的审计跟踪",
          desc: "每次更改、签核和配置更新均以加密方式记录。审计审计平台本身。"
        }
      ]
    },
    cta: {
      title: "准备好实现审计流程现代化了吗？",
      desc: "加入数百家已将审计管理和运营转变为有效且高效运营的领先企业。",
      btn: "今天开始您的评估"
    }
  },
  services: {
    research: {
      website: "访问 CBIB 趋势线",
      categories: [
        { title: "面向政府", description: "为政府决策提供支持的战略研究。" },
        { title: "面向数字经济", description: "研究产业数字基础设施和新型管理模式。" },
        { title: "面向行业", description: "提供政策和行业分析工具的指数研究产品。" },
        { title: "数据驱动", description: "连接产业数据、指标和知识图谱的数字化研究。" }
      ]
    },
    consulting: {
      banner: {
        title: "产业咨询服务",
        desc: "为生物医药产业发展提供一站式战略咨询服务"
      },
      intro: {
        title: "LPT产业咨询服务介绍",
        desc: "提供产业研究，规划，评估，监测等战略咨询服务"
      },
      advantage: {
        title: "LPT产业咨询服务独特优势"
      },
      values: {
        title: "BioMall 四大核心价值",
        items: [
          {
            title: "数据驱动",
            desc: "基于产业链，创新链，空间链，政府链的数据优势，提供专业化地区生物医药产业数据评价服务。"
          },
          {
            title: "一体化解决方案",
            desc: "形成“产业研究+规划蓝图+资源集成+平台落地”的理论指导，提供“顶天立地”独特的区域生物医药产业研究解决方案。"
          },
          {
            title: "专业服务团队",
            desc: "聚焦国内规模最大的生物医药产业研究专业团队。 核心骨干人员均拥有多年生物医药行业研究和咨询规划工作经验"
          }
        ]
      },
      appointment: {
        title: "预约我们的产业专家<br>了解更多有关LPT产业咨询服务详细信息",
        hotline: "拨打我们的咨询热线 000-000-0000"
      },
      witness: {
        title: "客户见证",
        desc: "全国各地150+政府与产业园合作成功案例"
      },
      list: [
        {
          tit: '产业研究',
          content: '基于CBIB对标分析，用数据解读区域产业发展的优劣势，量化发展差距，全面、清晰、客观展示区域产业发展情况。',
          images: [
            '中国生物医药产业蓝皮书',
            '广州开发区蓝皮书',
            '坪山生物产业基地蓝皮书',
            '日照经开区蓝皮书等'
          ]
        },
        {
          tit: '产业规划',
          content: '以数据驱动产业定位，明确发展目标，发展路径，集成专业化服务平台，形成从顶层设计--企业落地--服务运营的整体解决方案',
          images: [
            '重庆两江新区水土园区生物医药产业发展规划',
            '杭州医药港产业发展规划',
            '杭州高新区产业发展规划',
            '中关村生命园昌黎科创基地产业规划'
          ]
        },
        {
          tit: '项目评估',
          content: '以宏观经济评估，技术趋势评估结合园区生态环境建设评价、园区发展阶段评价的模型评估，为企业和品种招商落地',
          images: [
            '杭州高新区企业招商评估',
            '药明生物品种招商评估等'
          ]
        },
        {
          tit: '产业监测',
          content: '通过产业动态数据监测，形成区域经济主体、创新成果、政策变化等内容简报。帮助园区跟踪地域及产业发展，形成地区产业发展决策内参',
          images: [
            '国家发展改革委简报',
            '北京生物中心政策简报',
            '西安高新区简报等'
          ]
        },
        {
          tit: '专题研究',
          content: '从产业链、创新链、空间链、资金链等多个维度，剖析细分领域国内外产业现状及态势；通过与先进区域对标分析，明确区域细分领域优势与短板，提出发展策略与建议',
          images: [
            '国家发改委政策影响评价',
            '北京生物中心专题政策分析',
            '苏州工业园多领域专题研究',
            '广州市仿制药政策研究'
          ]
        }
      ],
      cases: [
        { tit: '上海市生物医药产业地图' },
        { tit: '上海市生物医药创新服务平台' },
        { tit: '广州市生物医药产业地图' },
        { tit: '中关村发展集团（规划+数字化中台）' },
        { tit: '中关村生命科学园智慧园区' },
        { tit: '华夏幸福数据中台' }
      ]
    },
    recruitment: {
      banner: {
        title: "云招商，生物医药细分领域企业选址专家",
        desc: "基于企业大数据、招商预测模型和细分领域投资选址逻辑<br />助力政府园区从传统招商向智能数字化招商转型"
      },
      challenges: {
        title: "2020，政府和园区招商面临新挑战！",
        items: [
          "疫情时期，如何推动招商工作快速复工复产？",
          "产业新基建浪潮下，如何加速产业发展，提升专业服务能力?",
          "如何实现园区价值与优势的有效推介，扩大园区品牌影响？",
          "如何洞察外部环境与行业趋势，提升专业性，促成谈判落地?"
        ]
      },
      cloud: {
        title: "云招商",
        desc: "创新和优化招商引资方式，线上招商一站式解决方案",
        list: [
          {
            tit: '线上招商会',
            content: '为园区组织策划线上招商推介会、线上洽谈会等直播宣传推介活动，提供会前策划推广、目标企业定向邀请、会后持续宣传等全流程服务。',
            features: [
              '<strong>一键发起</strong>快速举办在线招商',
              '<strong>专属二维码</strong>每个参会者都是VIP体验',
              '<strong>稳定流畅</strong>会议成果报告秒生成'
            ]
          },
          {
            tit: '智能招商SAAS服务',
            content: '基于企业大数据，整合招商线索，精准匹配区域招商策略和全国范围标的企业，为政府/园区精准对接有投资选址意向的企业线索。',
            features: [
              '<strong>定制化推荐模型</strong>基于地域和领域招商逻辑构建45个预测模型，随需调用',
              '<strong>持续的数据获取</strong>200万+医健企业、25万+产品库、70万+临床数据......',
              '<strong>强大的情报挖掘</strong>从海量数据中挖掘招商情报信息，实时输出招商线索',
              '<strong>有效的线索对接</strong>线上线下结合，对接关键决策人，促进项目落地'
            ]
          },
          {
            tit: '数字孪生园区',
            content: '开通园区营商环境数字化功能，园区VR实景，公共服务、技术、平台的数字化，在线还原园区真实的营商环境，让企业足不出户实现园区考察过程。',
            features: [
              '<strong>VR全景</strong>全面展现园区实景',
              '<strong>3D建模</strong>直观呈现未来规划',
              '<strong>微园区</strong>详细介绍园区配套'
            ]
          }
        ]
      },
      prediction: {
        line1: "45+生物医药细分领域的招商预测模型",
        line2: "快速形成专属于您园区的精准画像",
        line3: "输出动态更新的目标客户名单",
        btn: "申请免费体验"
      },
      location: {
        title: "药选址",
        subtitle: "药选址平台",
        desc: "有效触达超过2万家优质生物医药企业,为园区提供精准线索，提升园区品牌宣传",
        detail: "提供精准、真实、有效的企业选址线索和项目信息，实现需求方 and 资源方的高效匹配。完善园区多维度信息，搭建在线数字化营销平台。线上对接意向企业。",
        btn: "进入药选址"
      },
      witness: {
        title: "客户见证",
        desc: "150+政府和生物医药园区见证LPT品质服务"
      }
    },
    innovation: {
      title: "生物医药产业发展",
      subtitle: "面向生命健康经济的数字化研究与创新",
      banner: {
        title: "企业创新服务",
        desc: "打造生命健康产业新基建，加速园区中小企业高质量发展"
      },
      menu: {
        biomall: "BioMall - 生物医药产业创新服务综合体",
        medical: "医疗器械创新示范基地"
      },
      supplyChain: {
        title: "生物医药产业供应链至关重要",
        desc: "贯穿于生物医药研发、临床试验、商业性生产、上市推广等整个产品生命周期 用产业新基建数字化杠杆，为园区强链补链是当下的必然路径"
      },
      stakeholders: [
        {
          title: "园区政府",
          desc: "如何提升专业化服务能力， 为园区企业提供供应链更多选择？"
        },
        {
          title: "专业服务供应商",
          desc: "如何更加贴近客户， 进一步扩大市场覆盖面？"
        },
        {
          title: "园区企业",
          desc: "如何获得更专业的技术服务， 匹配更有价值的服务商？"
        }
      ],
      mall: {
        title: "走进 BioMall",
        desc: "BioMall是坐落园区、辐射区域、加快园区中小企业创新、助力园区专业服务水平的创新基础设施。通过线上、线下结合的方式，汇聚全球优质上游供应链资源，无缝、精准地向下游企业提供从研发到上市各类高质量并且具有成本优势的产品和技术服务。"
      },
      functions: {
        title: "BioMall 功能体系"
      },
      platforms: [
        {
          title: "数字化采购平台",
          features: ["商品搜索", "在线下单", "订单管理", "合约管理"]
        },
        {
          title: "数字化营销平台",
          features: ["精准获客", "询盘管理", "私域运营", "展会服务"]
        },
        {
          title: "数字化公共服务平台",
          features: ["政策申报", "研发服务", "人才服务", "金融服务"]
        },
        {
          title: "数字化供应链平台",
          features: ["智慧物流", "仓储管理", "配送服务", "关务服务"]
        }
      ],
      values: {
        title: "BioMall 四大核心价值",
        items: [
          "不仅是线上的数字化基建，更是线上和线下融合的全方位基建",
          "增强生物医药产业资源配置，使区域生物医药产业加速聚集",
          "化解我国生物医药发展过程中上游关键设备及材料卡脖子的问题",
          "不吸收优质供应商入驻，培植上游产业链，增加区域GDP和税收"
        ]
      }
    },
    common: {
      learnMore: "了解更多",
      getDemo: "获取产品演示",
      applyFree: "申请免费体验",
      buyNow: "立即购买",
      followUs: "扫码关注LPT",
      contactPhone: "联系电话：000-000-0000"
    }
  }
  ,
  actionManagement: {
    generalInfo: {
      evaluation: "评估"
    },
    submitChanges: "提交更改"
  }
};
